import React, { useState, useEffect, useRef, useCallback } from 'react';
import { isPaidPaymentStatus } from "../../utils/paymentStatus";
import { Form, Row } from 'react-bootstrap';
import { FaCalendarAlt, FaChevronDown, FaPlus } from 'react-icons/fa';
import { FiClock } from "react-icons/fi";
import DatePicker from 'react-datepicker';
import { Formik, useFormik } from 'formik';
import * as Yup from 'yup';
import DeleteIcon from "../../assets/images/fluent-color_warning-20.svg";
import * as apicall from '../../components/Apicall';
import { toast } from 'react-toastify';
import AppointmentModal from './AppointmentModal';
import PhoneInput from 'react-phone-input-2';
import ConfirmationModal from './ConfirmationModal';
import FollowUpConfirmModal from './FollowUpConfirmModal';
import 'react-phone-input-2/lib/style.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Dropdown } from "primereact/dropdown";
import FieldHelpTooltip from '../Help/FieldHelpTooltip';
import { HELP_CONTENT } from '../Help/HelpContent';
import { validMobileFormatByOwnPrefixTest, phoneCountryIso, getExpectedPhoneCountry } from '../../utils/phoneValidation';
import { MdClear, MdDelete } from 'react-icons/md';
import { fetchBookingStatusesForIndustry } from '../../utils/bookingStatus';
import { parseBookingRef } from '../../utils/bookingRef';
import ResourceField, { useActiveResources } from '../../pages/Vendor_bookings/ResourceField';
import { describeConflict } from '../../services/resourceService';

// Same loader Checkout.jsx uses for its Razorpay flow — duplicated here so
// this form can open Razorpay directly in edit mode without navigating to
// Checkout (an edit-mode booking is already fully created; there's nothing
// left for Checkout's cart/summary UI to do).
function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) { resolve(true); return; }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

const NewAppointment = ({ onClose, initialData = null, mode = 'new', timeSlots, bookingId, callApi, holidayDates, groupId: groupIdProp, checkoutReturnValues }) => {
    let service = JSON.parse(localStorage.getItem("services"));
  let vendor_id = JSON.parse(localStorage.getItem("userId"));
  const vendorProfile = JSON.parse(localStorage.getItem("vendorProfile")) || {};
  let { group_id: groupIdParam } = useParams();
  let navigate = useNavigate();
  const routeLocation = useLocation();
  // Edit can come from a route param (/:group_id) or be passed directly as a
  // prop (e.g. opened from a sidepanel with no route change) — either works.
  const bookingRef = groupIdProp || groupIdParam;
  const parsedRef = parseBookingRef(bookingRef);
  // An unreadable ref keeps its raw value so the load fails loudly, instead of
  // silently opening a blank new-booking form.
  let group_id = parsedRef.invalid ? String(bookingRef) : parsedRef.groupId || undefined;
    const taxPercentage = parseFloat(vendorProfile?.tax || 0);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showFollowUpConfirm, setFollowUpConfirm] = useState(false);
  const [showNoShowConfirm, setShowNoShowConfirm] = useState(false);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [calendarPickerOpen, setCalendarPickerOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(initialData?.details?.booking_date);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [insuranceProviders, setInsuranceProviders] = useState([]);
  console.log(insuranceProviders,"insuranceProviders")
  const [showInsuranceProviderDropdown, setShowInsuranceProviderDropdown] = useState(false);
  const [insuranceProviderSearchTerm, setInsuranceProviderSearchTerm] = useState('');
  const insuranceProviderRef = useRef(null);
  const timeSlotRef = useRef(null);
  const [showPatientNameDropdown, setShowPatientNameDropdown] = useState(false);
  // Switches the Patient Name field from "pick an existing family member"
  // (a closed, click-to-select list) into "type a brand new name" mode —
  // entered only via the explicit "+ Add Family Member" option, so users
  // never have to figure out that backspacing over the pre-filled name is
  // how you add someone new.
  const [addingNewPerson, setAddingNewPerson] = useState(false);
  const patientNameRef = useRef(null);
  // Tracks the last full mobile number that auto-triggered a Fetch Details
  // lookup, so typing further digits (or re-triggering onChange for the
  // same completed number) doesn't re-fire the API on every keystroke —
  // only a genuinely different completed number fires again.
  const lastAutoFetchedMobileRef = useRef(null);
  const userId = initialData?.details?.user_id;
  // const doctorId = initialData?.details?.doctor_id;
  const [currentStatus, setCurrentStatus] = useState(initialData?.details?.status || null);
  const [appointmentTimeState, setAppointmentTimeState] = useState(initialData?.appointmentTime || '');
  const [noShowMarked, setNoShowMarked] = useState(false);
  const [timeSlotsPassed, setTimeSlotsPassed] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [loadingDoctors, setLoadingDoctors] = useState(false);
  const [doctorPage, setDoctorPage] = useState(1);
  const [insuranceProvidersLoaded, setInsuranceProvidersLoaded] = useState(false);
  const vendorId = localStorage.getItem('vendorId');
  const [hasMoreDoctors, setHasMoreDoctors] = useState(true);
  const doctorDropdownRef = useRef(null);
  const [showDoctorDropdown, setShowDoctorDropdown] = useState(false);
  const [doctorSearchTerm, setDoctorSearchTerm] = useState('');
  const [doctorId, setDoctorId] = useState(initialData?.details?.doctor_id)
  const DOCTORS_PER_PAGE = 10;
const [services, setServices] = useState([]);
  const [servicesLoaded, setServicesLoaded] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [serviceDataLoaded, setServiceDataLoaded] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [groupedData, setGroupedData] = useState({});
  const [activeType, setActiveType] = useState("null");
  const [maxTime, setMaxTime] = useState(30);
  const [existingData, setExistingData] = useState([]);
  const [bookingProviderIds, setBookingProviderIds] = useState(null);
  const [editDisplayBookingId, setEditDisplayBookingId] = useState(null);
  const [partner_id, setPartner_id] = useState(1);
    const [partners, setPartners] = useState([]);
  console.log(serviceData,"serviceData")
  // AddProvider.jsx reads currency SYNCHRONOUSLY on first render (from
  // location.state / localStorage), so the phone field's country is correct
  // from mount and react-phone-input-2 renders "+91"/"+971" immediately.
  // This form used to start hardcoded at "AED" and only switch country
  // after the async ezpMyProfile fetch below resolved — react-phone-input-2
  // takes a different, buggier internal path when `country` changes AFTER
  // mount than when it's correct from the start, and was silently dropping
  // the dial-code prefix (flag showed fine, "+91" text never appeared).
  // Seed from localStorage the same way AddProvider does so it's right
  // immediately; the effect below still re-confirms it against the fresh
  // profile fetch.
  const [currency, setCurrency] = useState(
    () => localStorage.getItem("currency") || "AED"
  );
  const [selectedService, setSelectedService] = useState(service?.[0] || {});
  const latestRequestRef = useRef(0);
  const latestSlotsRequestRef = useRef(0);
  const latestBookingRequestRef = useRef(0);
  const bookingLoadedGroupRef = useRef(null);
  // fetchServiceData runs twice per Specialization pick (once from the
  // dropdown's onChange, once again from the [selectedService] effect) and
  // auto-fills Specialization Type from the offerings' `added` flags once its
  // request resolves. If the user manually picks a Specialization Type
  // before that resolves, the slower response was landing afterward and
  // wiping their pick back to the default — showing "Select Specialization
  // Type" even though they'd just chosen one. This flag records that the
  // user has taken over the field for the current Specialization, so
  // fetchServiceData stops overwriting it; it's reset whenever Specialization
  // changes so a fresh pick still gets its normal defaults.
  const specializationTypeUserEditedRef = useRef(false);
  // Restores serviceData saved before navigating to Checkout, so returning
  // via "+ Add Item" doesn't need to re-fetch/re-derive offerings — same
  // technique Bookings.jsx uses for its own checkout-return flow.
  const checkoutReturnServiceDataRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [timeRange, setTimeRange] = useState({ startTime: "", endTime: "" });
  const [timeSelect, setTimeSelect] = useState("");
  const [providerSelected, setProviderSelected] = useState([]);
  const [initialAppointments, setInitialAppointments] = useState([]);
  const [user_id, setUser_id] = useState(0);
  // Book-for-self-or-dependent: options are the found customer themselves
  // plus any existing family members under them (same mobile number).
  // Picking one uses that identity as-is; typing a new name creates a new
  // dependent under the found customer (never touches ezp_customers).
  const [dependentOptions, setDependentOptions] = useState([]); // [{id, name, isCustomer}]
  const [selectedPersonId, setSelectedPersonId] = useState(null);
  const [priceSection, setPriceSection] = useState([]);
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [dateSelect, setDateSelect] = useState("");
  // Falls back to dateSelect (set by getDataByID's self-fetch) for the
  // groupId/route-driven edit path, which has no initialData prop to read.
  const bookedDate = initialData?.details?.booking_date || dateSelect;
  const [paidAmount, setPaidAmount] = useState(0);
    const [discount, setDiscount] = useState(0);
  const [selectedOfferings, setSelectedOfferings] = useState([]);
const formikRef = useRef(null);
  const [bookingStatus, setBookingStatus] = useState([]);
    const [profileIndustry, setProfileIndustry] = useState([]);
  const [recentBookings, setRecentBookings] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
const [firstLocation, setFirstLocation] = useState(null);
  const [editable, setEditable] = useState(true);
  // Optional bookable resource - an examination room for a clinic. Kept out
  // of Formik like paidAmount/editable, and only sent to the API when the
  // field is on screen, so a clinic with no rooms set up is unaffected.
  const { resources: activeResources } = useActiveResources();
  const [resourceIds, setResourceIds] = useState("");
  const [resourceCurrentName, setResourceCurrentName] = useState("");
  const showResourceField = activeResources.length > 0 || !!resourceIds;
  const [payingOnline, setPayingOnline] = useState(false);

  const isClinicService = profileIndustry === 1;

const [initialValues, setInitialValues] = useState({
 partner: partner_id,
  org_id: "",
  patientName: "",
  // Seeding just the dial code (e.g. "91") instead of "" so the field
  // starts with "+91" actually visible/typeable rather than relying on
  // react-phone-input-2 to auto-fill it on mount — that auto-fill wasn't
  // firing reliably here, leaving the field showing nothing but the flag.
  // Edit mode overwrites this with the real loaded number anyway (see
  // getDataByID's setF("mobileNumber", ...) below).
  mobileNumber: getExpectedPhoneCountry(
    localStorage.getItem("currency") || "AED"
  ).dialCode,
  email: "",
  age: "",
  gender: "",

  house_no: "",
  area: "",
  location: "",
  location_id: "",
  state: "",
  landmark: "",
  country: "",
  lat: "",
  lng: "",

  insuranceNumber: "",
  insuranceProvider: "",

  doctors: [],
  providers:[],

  appointmentDate: "",
  appointmentTime: "",
  selectedTimeSlots: [],

  specialization: "",
  specialization_type: [],

  // Placeholder only, until either the "Booked" default effect below (new
  // appointment) or getDataByID's fetch (edit mode) overwrites it with the
  // real id/status.
  status: "",
    payment: 0,
});
 const validationSchema = Yup.object().shape({
  patientName: Yup.string()
    .required("Patient name is required")
    .min(2)
    .max(50),

  // age field temporarily hidden — see the commented-out Age input further down.
  // age: Yup.number()
  //   .required("Age is required")
  //   .positive()
  //   .integer()
  //   .max(120),

  gender: Yup.string().required("Gender is required"),

  mobileNumber: Yup.string()
    .required("Mobile number is required")
    .min(10, "Enter valid mobile number")
    .test("country-match-profile", function (value) {
      if (!value) return true;
      // Editing an existing booking never lets you change this field
      // (disabled={isEditMode} below) — it's read-only history, and can
      // legitimately be from a different country than the vendor's
      // profile's *current* setting (e.g. profile switched from India to
      // UAE after this booking was made). Validating it against today's
      // profile country here was blocking edits (time/doctor/status) on
      // any booking whose country no longer matches, with no way to fix
      // the "error" since the field can't be touched.
      if (isEditMode) return true;

      const selectedPartnerId = Number(this.parent?.partner);
      const selectedPartner = partners?.find(
        (p) => Number(p.id) === selectedPartnerId
      );
      const isUtilstopProfile =
        selectedPartner?.partner_name?.trim().toLowerCase() === "utilstop";
      if (isUtilstopProfile) return true;

      const cleanedValue = value.replace(/\D/g, "");
      const wrongPrefix = currency === "INR" ? "971" : "91";
      const expectedCountry = currency === "INR" ? "India" : "UAE";
      if (cleanedValue.startsWith(wrongPrefix)) {
        return this.createError({
          message: `Please select a ${expectedCountry} number — this matches your profile's country.`,
        });
      }
      return true;
    })
    .test("valid-mobile-format", validMobileFormatByOwnPrefixTest()),

  insuranceNumber: Yup.string().nullable(),
  insuranceProvider: Yup.string().nullable(),

  doctors: Yup.array()
    .min(1, "Select doctor")
    .required("Doctor is required"),

  appointmentDate: Yup.string()
    .required("Appointment date is required"),

  appointmentTime: Yup.string()
    .required("Appointment time is required"),

  specialization: Yup.string()
    .required("Specialization is required"),

  specialization_type: Yup.array()
    .min(1, "Select Specialization Type "),
});
  const getBookingStatus = async () => {
    try {
      // Fetch industry fresh from ezpMyProfile rather than trusting
      // localStorage.userDetails, which is written by several independent
      // fetches elsewhere and can be stale right after login.
      const profileRes = await apicall.get("ezpMyProfile");
      const industry = profileRes?.data?.[0]?.industry;
      setProfileIndustry(Number(industry));

      setBookingStatus(await fetchBookingStatusesForIndustry(apicall.get, industry));
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

    const getPaymentStatus = async () => {
      try {
        const response = await apicall.get("get_ezp_payment_status");
        console.log(response,"response------")
        if (response.success) {
          setPaymentStatus(response.data);
        } else {
          setPaymentStatus([]);
        }
      } catch (error) {
        console.error("Error fetching Booking Status:", error);
        toast.error("Failed to fetch Booking Status:");
      }
    };
    useEffect(() => {
            getBookingStatus();
           getPaymentStatus();
    }, []);

    // Default Payment to the first option (Pending) for a fresh appointment
    // — edit mode already loads the booking's real payment status via
    // getDataByID, so don't override that.
    useEffect(() => {
      if (!group_id && paymentStatus.length > 0) {
        formikRef.current?.setFieldValue("payment", paymentStatus[0].id);
      }
    }, [paymentStatus]);

    // Default Status to "Booked" for a fresh appointment — it hasn't been
    // checked in yet, so it shouldn't start life as "Checked In". Looked up
    // by name (not a hardcoded id) since the status list is industry-specific
    // and fetched from the backend. Edit mode already loads the booking's
    // real status via getDataByID, so don't override that.
    useEffect(() => {
      if (!group_id && bookingStatus.length > 0) {
        const booked = bookingStatus.find(
          (s) => s.name?.trim().toLowerCase() === "booked"
        );
        if (booked) {
          formikRef.current?.setFieldValue("status", booked.id);
          setCurrentStatus(booked.id);
        }
      }
    }, [bookingStatus]);

// Shared validation used before both a normal submit and a direct
// in-page "Pay Online" (edit mode only — see handlePayOnline).
const validateAppointmentForm = (values) => {
  let flag = true;

  const addedService = serviceData?.filter(ele => ele?.added);

  if (addedService.length === 0) {
    toast.error("Select Service Offerings to proceed");
    flag = false;
  }

  if (!values.doctors || values.doctors.length === 0) {
    toast.error("Select Doctor");
    flag = false;
  }

  if (!values.appointmentTime) {
    toast.error("Select Time Slot");
    flag = false;
  }

  return flag;
};

// Builds the full booking payload (pricing, providers, gender/location
// coercion, dependent resolution, group_id) from raw Formik values — shared
// by the normal submit and by handlePayOnline, which needs the exact same
// payload shape to attach to the booking once Razorpay/Stripe confirms
// payment. Returns null if a required side-effect (creating a new
// dependent) fails, in which case the caller should abort.
const buildAppointmentValues = async (rawValues, setSubmitting) => {
  const values = { ...rawValues };
const updatedPriceSection = priceSection.map((item) => {
  if (item.type === "service") {
    const matchedService = serviceData.find(
      (s) => s.service_offering_id === item.service_offering_id
    );

    return {
      ...item,
      service_id: matchedService?.service_id || 0,
      service_type_id: matchedService?.service_type_id || 0,
      service_offering_id: matchedService?.service_offering_id || 0,
      service_name: matchedService?.service_name || "", 
    };
  }
  return item;
});
      values.editable = editable ? 1 : 0;

    // This form has no address/location fields for the user to edit at all
    // (unlike Bookings.jsx, where this comparison-against-firstLocation
    // logic originated) — firstLocation only ever gets set by the Fetch
    // Details flow, which isn't part of the edit-mode flow, so comparing
    // against it here was always false-positive "changed" in edit mode,
    // triggering a backend location UPDATE with no location_id and
    // breaking its SQL. Location genuinely never changes through this form.
    let isLocationChanged = false;
      values.existingUserId = user_id;

    let doctorIds = values.doctors?.join(", ");

let firstSlot = values.selectedTimeSlots?.[0] || values.appointmentTime;
const formattedTimeArr = convertTo24HourFormat([firstSlot]);
values.time = formattedTimeArr?.[0] || firstSlot;

    values.date = values.appointmentDate;
    values.isLocationChanged = isLocationChanged;
    // location_id must reach the backend as a plain integer (or 0) — the raw
    // SQL INSERT it feeds writes it unquoted, and anything that isn't a
    // clean scalar (e.g. an empty array slipping in from a stale/edit-mode
    // field value) renders as a blank slot in the VALUES list and breaks
    // the query with a syntax error.
    const rawLocationId = Array.isArray(values.location_id)
      ? values.location_id[0]
      : values.location_id;
    values.location_id = Number(rawLocationId) || 0;

    values.serviceData = serviceData;
values.priceSection = updatedPriceSection;
    values.providers = doctorIds;
    // "" clears; leaving the key out keeps the booking's resource untouched.
    if (showResourceField) values.resource_ids = resourceIds;
    values.paid_amount = paidAmount;
    values.userName = values.patientName;
values.phoneNumber = values.mobileNumber;
values.currency = currency;
    // The Gender dropdown works in "Male"/"Female" strings (and getDataByID
    // converts the backend's raw 1/2 to those same strings for display) —
    // but the backend's INSERT/UPDATE queries write this value unquoted,
    // expecting the numeric 1/2 it was always given. Sending "Male" through
    // made it into the raw SQL as an unquoted identifier and broke the query
    // ("Unknown column 'Male' in 'field list'").
    values.gender = values.gender === "Male" ? 1 : values.gender === "Female" ? 2 : values.gender;
    // Same endpoint handles both create and edit — passing group_id (present
    // only when this form was opened for an existing booking) makes the
    // backend update that booking's rows instead of inserting a new one.
    if (group_id) {
      values.group_id = group_id;
    }


    // Resolve who this appointment is actually for: the found customer
    // themselves (no dependent_id — booking stays under ezp_customers as
    // today), an existing family member (use their dependent id), or a
    // brand-new family member typed in (create them under this same
    // customer first, then use the new id). A brand-new phone number with
    // no dependentOptions at all is unaffected — same as before.
    if (dependentOptions.length > 0 && !group_id) {
      const typedName = (values.patientName || "").trim();
      const matchedOption = dependentOptions.find(
        (o) => o.name.trim().toLowerCase() === typedName.toLowerCase()
      );

      if (matchedOption?.isCustomer) {
        values.dependent_id = null;
      } else if (matchedOption) {
        values.dependent_id = matchedOption.id;
      } else if (typedName) {
        try {
          const depRes = await apicall.post(
            {
              user_id: user_id,
              name: typedName,
              mobile_number: values.mobileNumber,
              gender: values.gender,
            },
            "ezp_add_dependent"
          );
          if (depRes?.success && depRes?.data?.id) {
            values.dependent_id = depRes.data.id;
          }
        } catch (depErr) {
          console.error("Failed to create dependent:", depErr);
          toast.error("Failed to save family member details");
          setSubmitting?.(false);
          return null;
        }
      }
    }

    return values;
};

const onSubmitFormn = async (values, { setSubmitting }) => {
  try {
    if (!validateAppointmentForm(values)) return;

    const builtValues = await buildAppointmentValues(values, setSubmitting);
    if (!builtValues) return;

    console.log("FINAL VALUES (BOOKING FORMAT)", builtValues);

    if (group_id) {
      // Edit mode: update the booking directly, no Checkout step — same as
      // Bookings.jsx's edit-mode path.
      const response = await apicall.post(builtValues, "create_ezp_booking");

      if (response?.status === 200) {
        // Reload only after the toast has had a chance to actually render —
        // firing it in the same tick as toast.success() was tearing the page
        // down mid-animation, so the message flashed by half-drawn/cropped
        // instead of being readable.
        const clashNote = response.resource_conflicts
          ? `. Note: the room is also booked at this time (${describeConflict(response.resource_conflicts)})`
          : "";
        toast.success(`Appointment updated successfully${clashNote}`, {
          autoClose: clashNote ? 6000 : 2000,
          onClose: () => window.location.reload(),
        });
      } else {
        toast.error(response?.message || response?.error || "Something went wrong");
      }
    } else {
      // New appointment: go to Checkout to select a payment method (cash vs
      // online), same as Bookings.jsx — the booking itself is only created
      // there once payment method is confirmed. Checkout reopens this form
      // inline as a sidepanel for Back / "+ Add Item" (see isAppointmentForm),
      // rather than navigating to a separate page.
      builtValues.isAppointmentForm = true;
      // Close whichever parent panel is showing this form (e.g. Navbar's
      // own "New Appointment" offcanvas) — Navbar never unmounts on this
      // navigation, so without this its stale panel stays open on top of
      // the freshly-rendered Checkout page.
      onClose?.();
      navigate("/checkout", {
        state: {
          bookingValues: builtValues,
          partners,
          partner_id,
        },
      });
    }

  } catch (e) {
    console.log(e);
    toast.error("Something went wrong");
  }
};

// Pay Online (edit mode only): charges the booking's outstanding total via
// Razorpay (INR) or Stripe (non-INR), right here in the sidepanel — no
// Checkout navigation, since an existing booking has nothing left for
// Checkout's cart UI to do. Mirrors Checkout.jsx's handleConfirm online
// branch: create the order, open the gateway, and on success attach the
// transaction (invoice_id / payment_gateway / payment=7) to the booking via
// the same create_ezp_booking update call the normal edit-submit uses.
const handlePayOnline = async () => {
  const values = formikRef.current?.values;
  if (!values) return;
  if (!validateAppointmentForm(values)) return;

  const totalObj = priceSection?.find((item) => item.name === "Total");
  const totalAmount = Number(totalObj?.amount || 0);
  if (!totalAmount) {
    toast.error("Nothing to charge — total amount is 0.");
    return;
  }

  setPayingOnline(true);
  try {
    const builtValues = await buildAppointmentValues(values);
    if (!builtValues) {
      setPayingOnline(false);
      return;
    }

    const orderRes = await apicall.post(
      {
        amount: totalAmount.toFixed(2),
        currency,
        group_id,
        success_return_url: window.location.href,
        cancel_return_url: window.location.href,
      },
      "create_ezp_payment_order"
    );

    if (!orderRes?.success) {
      toast.error("Could not create payment order: " + (orderRes?.message || "Unknown error"));
      setPayingOnline(false);
      return;
    }

    if (orderRes.payment_gateway === "stripe") {
      // UAE/non-INR profiles: Stripe's hosted checkout can't open inline —
      // same redirect Checkout.jsx does for its own Stripe branch.
      // toast.info("Redirecting to Stripe checkout...");
      window.location.href = orderRes.session_url;
      return;
    }

    // INR profiles: Razorpay, opened right here in the modal.
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      toast.error("Failed to load Razorpay SDK. Check internet connection.");
      setPayingOnline(false);
      return;
    }

    const rzp = new window.Razorpay({
      key: orderRes.key,
      amount: orderRes.amount,
      currency: orderRes.currency,
      name: "UtilStop",
      description: "Service Booking",
      order_id: orderRes.order_id,
      prefill: {
        name: builtValues.userName || "",
        contact: builtValues.phoneNumber || "",
        email: builtValues.email || "",
      },
      theme: { color: "#d01c4c" },
      handler: async (response) => {
        try {
          const bookingRes = await apicall.post(
            {
              ...builtValues,
              payment: 7,
              invoice_id: response.razorpay_payment_id,
              payment_gateway: "razorpay",
              paid_amount: totalAmount.toFixed(2),
            },
            "create_ezp_booking"
          );
          if (bookingRes?.status === 200 || bookingRes?.booking_id) {
            toast.success("Payment successful! Appointment updated.", {
              autoClose: 2000,
              onClose: () => window.location.reload(),
            });
          } else {
            // Payment already went through — say so explicitly rather than
            // a generic failure message, same as Checkout.jsx's handler.
            toast.error(
              "Payment was successful, but updating the appointment failed: " +
              (bookingRes?.message || "Unknown error") +
              ". Please contact support with your payment reference."
            );
          }
        } catch (e) {
          toast.error("Payment verification failed. Contact support.");
        } finally {
          setPayingOnline(false);
        }
      },
      modal: {
        ondismiss: () => {
          setPayingOnline(false);
          toast.info("Payment cancelled.");
        },
      },
    });
    rzp.open();
  } catch (e) {
    console.log(e);
    toast.error("Something went wrong");
    setPayingOnline(false);
  }
};

  const cleanCrewSlots = (slots) => {
    const grouped = {};

    // Step 1: Group by provider_id
    slots.forEach((slot) => {
      const id = slot.extendedProps.provider_id;
      if (!grouped[id]) grouped[id] = [];
      grouped[id].push(slot);
    });

    let result = [];

    // Step 2: Process each crew separately
    Object.values(grouped).forEach((group) => {
      const bookedSlots = group.filter((s) => s.status === 2);

      const cleaned = group.filter((slot) => {
        // keep booked slots
        if (slot.status === 2) return true;

        // remove overlap only within same crew
        const isOverlapping = bookedSlots.some((booked) => {
          return (
            new Date(slot.start) < new Date(booked.end) &&
            new Date(slot.end) > new Date(booked.start)
          );
        });

        return !isOverlapping;
      });

      result.push(...cleaned);
    });

    return result;
  };
    const fetchPartners = async () => {
      try {
        const response = await apicall.get("partners");
        setPartners(response.data);

        if (!group_id) {
          const selfPartner = response?.data?.find(
            (p) => p?.partner_name?.trim().toLowerCase() === "self"
          );
          const defaultPartnerId = selfPartner?.id ?? response?.data?.[0]?.id;
          setPartner_id(defaultPartnerId);
          formikRef.current?.setFieldValue("partner", defaultPartnerId);
          // setInitialValues({
          //   partner: response?.data[0]?.id,
          //   org_id: "",
          //   userName: "",
          //   phoneNumber: "",
          //   email: "",
          //   house_no: "",
          //   area: "",
          //   location: "",
          //   location_id: "",
          //   state: "",
          //   landmark: "",
          //   country: 1,
          //   lat: "",
          //   lng: "",
          //   status: "",
          //   payment: "",
          // });
        }
      } catch (error) {
        console.error("Error fetching fetchPartners:", error);
        toast.error("Failed to fetch fetchPartners");
      }
    };
useEffect(() => {
  if (serviceTypes.length > 0) {
    setActiveType(serviceTypes[0]);

    formikRef.current?.setFieldValue(
      "specialization_type",
      serviceTypes[0]
    );
  }
}, [serviceTypes]);

useEffect(() => {
  if (!initialData) {
    const today = new Date();
    const formatted = today.toISOString().split("T")[0];

    formikRef.current?.setFieldValue(
      "appointmentDate",
      formatted
    );

    setSelectedDate(formatted);
  }
}, [initialData]);

const formValues = formikRef.current?.values;


const fetchDoctorSlots = async (providerIds, date) => {
  if (!providerIds?.length || !date) return;

  try {
     let d1 = new Date(date)
      d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    let q1 = `getWokerAvailableSlots?date=${d1}`;

    if (selectedService?.service_id) {
      q1 += `&&service_id=${selectedService.service_id}`;
    }

    q1 += `&&provider_ids=${providerIds.join(",")}`;

    const res = await apicall.get(q1);

    let data = res?.data || [];

    setInitialAppointments(data);

    let filtered = cleanCrewSlots(data);

    setFilteredAppointments(filtered);

const slots = filtered.map((item) => {
  const start = new Date(item.start);

  const end = new Date(start);
  end.setMinutes(start.getMinutes() + maxTime);

  const format = (date) =>
    date.toTimeString().slice(0, 5);

  return `${format(start)} - ${format(end)}`;
});

    setAvailableTimeSlots(slots);

  } catch (e) {
    console.log("error fetching doctor slots", e);
  }
};

useEffect(() => {
  if (formValues?.doctors?.length > 0 && formValues?.appointmentDate) {
    const selectedDoctors = doctors.filter(d =>
      formValues.doctors.includes(d.id)
    );

    const providerIds = selectedDoctors.map(
      d => d.serviceProvider_id
    );

    // fetchDoctorSlots(providerIds, formValues.appointmentDate);
    // getWorkerAvailableSlots only takes a date — passing providerIds as a
    // second arg silently became the `date` param (extra args are ignored,
    // not merged), corrupting new Date(...) into Invalid Date and producing
    // "Inval" everywhere downstream in the time-slot list.
    getWorkerAvailableSlots(formValues.appointmentDate, undefined, formValues.doctors?.[0]);
  }
}, [formValues?.doctors, formValues?.appointmentDate]);
useEffect(() => {
  if (initialData?.details) {
    const serviceId = initialData.details.service_id;

    const serviceObj = services.find(s => s.service_id === serviceId);
    if (serviceObj) {
      setSelectedService(serviceObj);
      fetchServiceData(serviceObj);
    }

    setSelectedOfferings(
      initialData.details.service_offerings || []
    );
  }
}, [initialData, services]);
function getPrice() {
  try {
    let prices = [];
    let total = 0;

    const filteredServices = serviceData.filter(i =>
      selectedOfferings.includes(i.service_offering_id)
    );

    for (let eachData of filteredServices) {
      let name = eachData.service_name;

      if (eachData.service_type_name && eachData.service_type_name !== "null") {
        name += ` - ${eachData.service_type_name}`;
      }

      name += ` - ${eachData.service_offering_name}`;

      const amount = Number(eachData.amount || 0);

      prices.push({
        name,
        type: "service",
        service_offering_id: eachData.service_offering_id,
        amount,
      });

      total += amount;
    }

    const discountValue = Number(discount || 0);

    prices.push({
      name: "Discount",
      type: "discount",
      amount: discountValue,
    });

    const taxAmount = (total * taxPercentage) / 100;

    prices.push({
      name: `Tax (${taxPercentage}%)`,
      type: "tax",
      amount: taxAmount.toFixed(2),
    });

    const finalTotal = total + taxAmount - discountValue;

    prices.push({
      name: "Total",
      type: "total",
      amount: finalTotal.toFixed(2),
    });

    setPriceSection(prices);

  } catch (e) {
    console.log(e);
  }
}
function priceChange(value, data) {
  try {
    if (data.type === "service") {
      setServiceData(prev =>
        prev.map(i =>
          i.service_offering_id === data.service_offering_id
            ? { ...i, amount: value }
            : i
        )
      );
    }

    if (data.type === "discount") {
      setDiscount(Number(value));
    }

    if (data.isCustom) {
      setPriceSection(prev =>
        prev.map(i =>
          i.id === data.id ? { ...i, amount: value } : i
        )
      );
    }

  } catch (e) {
    console.log(e);
  }
}
useEffect(() => {
  getPrice();
}, [serviceData, selectedOfferings, discount]);
  useEffect(() => {
    let today = new Date();
    let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    setDateSelect(d2);
    // getAllServices();
    fetchPartners();
  }, [group_id]);

console.log("selectedService---", selectedService,serviceTypes);
  useEffect(() => {
    fetchServiceData(selectedService);
  }, [selectedService]);

  const fetchServiceData = async (data, partnerID = 1) => {
    try {
      if (checkoutReturnServiceDataRef.current) {
        const saved = checkoutReturnServiceDataRef.current;
        checkoutReturnServiceDataRef.current = null;
        setServiceData(saved);
        setServiceDataLoaded(true);
        let sumTime = 0;
        for (const i of saved) {
          if (i?.added) sumTime += (i?.time_required || 0) + (i?.buffer || 0);
        }
        setMaxTime(sumTime);
        return;
      }
      if (data?.service_id) {
        setServiceDataLoaded(false);
        let p1 = partner_id ? partner_id : partnerID;
        // setLoading(true);
        const response = await apicall.get(
          `offeringFromService?service_id=${data?.service_id}&&is_partner=true&&partner_id=${p1}`
        );
        // setLoading(false);

        console.log("existingData----->>>>", response);
        let copyResponse;
        if (response?.data) {
          copyResponse = JSON.parse(JSON.stringify(response?.data));
          // offeringFromService returns both active and inactive offerings
          // (Admin Setup needs to show inactive ones so they can be
          // reactivated) — while booking, only active ones should be
          // selectable here.
          copyResponse = copyResponse.filter((item) => Number(item.is_active) === 1);
        }

        let offering_id = [];
        let type_name;

        if (response.success && copyResponse) {
          for (let i of existingData) {
            for (let j of copyResponse) {
              if (i.service_offering_id === j.service_offering_id) {
                // console.log("is there-----");
                j.added = true;
                if (!offering_id.includes(i.service_offering_id)) {
                  j.amount = Number(i.price);
                  offering_id.push(i.service_offering_id);
                }
                break;
              }
            }
          }
          // console.log("offering_id---", offering_id);
          // console.log("copyResponse---", copyResponse);

          // No default selection for a fresh appointment — only mark items
          // added when they match the booking's actual saved offerings
          // (existingData, edit mode). The user picks Specialization Type
          // themselves rather than one being pre-selected for them.
          let c1 = copyResponse?.map((ele) => ({
    ...ele,
    added: ele.added || false,
    amount: Number(ele.amount || ele.price || 0)
  }));

          let sumTime = 0;
          for (let i of copyResponse) {
            if (i?.added) {
              let t1 = i?.time_required + i?.buffer;
              sumTime += t1;
            }
          }
          setMaxTime(sumTime);

          if (!type_name) {
            setActiveType(
              copyResponse[0]?.service_type_name
                ? copyResponse[0]?.service_type_name
                : "null"
            );
          }

          setServiceData(c1);

          // Keep the Specialization Type MultiSelect in sync with the
          // `added` flag computed above — index 0 by default for a fresh
          // appointment, or the booking's actual saved offerings in edit
          // mode — instead of leaving the field visually empty while
          // serviceData already has a default/real selection internally.
          if (!specializationTypeUserEditedRef.current) {
            const defaultOfferingIds = c1
              .filter((ele) => ele.added)
              .map((ele) => ele.service_offering_id);
            formikRef.current?.setFieldValue("specialization_type", defaultOfferingIds);
            setSelectedOfferings(defaultOfferingIds);
          }
        } else {
          setServiceData([]);
        }
      }
    } catch (error) {
      console.log("err---", error);
      toast.error("Failed to fetch service offerings....");
      // setInitialServiceData([]);
      setServiceData([]);
    } finally {
      // setLoading(false);
      if (data?.service_id) {
        setServiceDataLoaded(true);
      }
    }
  };
    async function getDataByID(allServicesData) {
      // The outer getAllServices()->getDataByID() chain legitimately runs
      // twice on an edit-mode load: once with the default partner_id
      // (before this function's own setPartner_id call below updates it),
      // then again once that update triggers the [partner_id] effect. That
      // repopulated every field a second time (Mobile Number, Patient Name,
      // etc.) even though nothing but the Specialization-matching actually
      // needed the corrected partner_id — visible as those fields flickering
      // shortly after the page finished loading. Now this function fetches
      // the booking's own correct partner's services itself instead of
      // depending on that outer retrigger, so it's correct on the first
      // pass — and skips doing the whole populate again if some other
      // trigger calls it a second time for the same booking.
      if (bookingLoadedGroupRef.current === group_id) return;
      // Mark this synchronously, before the first `await`, not after the
      // fetch resolves — the outer chain's second invocation fires only a
      // moment after the first one starts (well before its fetch settles),
      // so setting this later left a window where both calls still slipped
      // through and repopulated the form back to back.
      bookingLoadedGroupRef.current = group_id;
      const requestId = ++latestBookingRequestRef.current;
      try {
        setLoading(true);
        const response = await apicall.get(
          `get_ezp_booking_by_id?group_id=${group_id}`
        );
        console.log("get_ezp_booking_by_id response----", response);
        setLoading(false);
        if (requestId !== latestBookingRequestRef.current) return;
        if (response.success && response.data) {
          console.log("response.data----", response.data);
  
          setExistingData(response?.data || []);
          let {
            customer_id,
            partner,
            org_id,
            user_name,
            first_name,
            email,
            gender,
            phone_number,
            house_no,
            area,
            state,
            location,
            location_id,
            landmark,
            status,
            payment,
            lat,
            lng,
            service_id,
            service_date,
            service_time,
            discount,
            provider,
            display_booking_id,
            editable,
            additional_info,
            total_paid_amount,
            service_type_name,
            insurance_number,
            insurance_provider,
          } = response.data[0];
          // Populate the actual Formik form with this booking's data — this used
          // to be a no-op (setInitialValues was never called), so opening the
          // sidepanel to edit a booking showed a blank form with none of the
          // patient/specialization/status details actually loaded.
          const trimmedTime = String(service_time || "").slice(0, 5);
          const offeringIds = (response.data || [])
            .map((row) => row?.service_offering_id)
            .filter(Boolean);
          const patientName =
  user_name ||
  response.data[0]?.dependent_name ||
  `${first_name || ""}`.trim();
          const setF = (field, value) => formikRef.current?.setFieldValue(field, value);
          setF("partner", partner);
          setF("org_id", org_id || "");
          setF("patientName", patientName);
          setF("mobileNumber", phone_number || "");
          setF("email", email || "");
          setF("house_no", house_no || "");
          setF("area", area || "");
          setF("location", location || "");
          setF("location_id", location_id || "");
          setF("state", state || "");
          setF("landmark", landmark || "");
          setF("lat", lat || "");
          setF("lng", lng || "");
          setF("insuranceNumber", insurance_number || "");
          // Same numeric-vs-string mismatch as Gender/the other setFieldValue
          // above — the Dropdown's options use numeric values.
          setF("insuranceProvider", insurance_provider ? Number(insurance_provider) : "");
          // Same fix applies here: the Status/Payment Dropdowns' options are
          // built as { value: s.id } (numbers from bookingStatus/paymentStatus).
          // Loading the raw (possibly string) DB value straight in without
          // coercion left it unable to strictly-match any option — the
          // Dropdown could show the wrong/blank pre-selection, and a manual
          // pick could still submit alongside a stale uncoerced value.
          setF("status", status != null && status !== "" ? Number(status) : "");
          setF("payment", payment != null && payment !== "" ? Number(payment) : "");
          setF("appointmentDate", service_date);
          setF("appointmentTime", trimmedTime);
          setF("selectedTimeSlots", trimmedTime ? [trimmedTime] : []);
          setF("specialization", service_id);
          setF("specialization_type", offeringIds);
          // The Gender Dropdown's options use numeric values (1/2, see the
          // `options` prop below), not the strings "Male"/"Female" — setting
          // a string here left the dropdown showing nothing on edit since it
          // never matched either option.
          setF("gender", Number(gender) === 1 ? 1 : Number(gender) === 2 ? 2 : "");
          setSelectedOfferings(offeringIds);
          setCurrentStatus(status);
          setEditDisplayBookingId(display_booking_id);
          setBookingProviderIds(
            String(provider || "")
              .split(",")
              .map((p) => Number(p.trim()))
              .filter((n) => Number.isFinite(n) && n > 0)
          );
          setDateSelect(service_date);
          setTimeSelect(service_time);
          // setDiscount(discount);
          setAdditionalNotes(additional_info);
          setPaidAmount(total_paid_amount);
          // Parse custom services from backend
          const customString = response.data[0]?.custom_items;
          // if (phone_number) {
          //   getRecentBookings(phone_number);
          // }
          if (customString) {
            const customArray = customString.split("||").map((item) => {
              const [name, amount] = item.split("::");
  
              return {
                id: Date.now() + Math.random(),
                name: name,
                amount: amount,
                isCustom: true,
              };
            });
  
            setPriceSection(customArray);
          }
          setPartner_id(partner);
          // setDisplay_booking_id(display_booking_id);
          setEditable(editable);
          setResourceIds(String(response.data[0]?.resource_ids || ""));
          setResourceCurrentName(String(response.data[0]?.resource_names || ""));
          setUser_id(customer_id);
          setActiveType(service_type_name || "null");

          let providers = provider?.split(",")?.map((ele) => Number(ele));

          // Fetch this booking's own partner's services directly instead of
          // trusting `allServicesData` (which reflects whatever partner_id
          // was active when the outer getAllServices() call happened to
          // run — the default one on the very first pass, not necessarily
          // this booking's actual partner).
          let servicesForMatching = allServicesData;
          try {
            const svcResponse = await apicall.get(
              `get_ezp_service?partner_id=${partner}`
            );
            if (svcResponse?.success && svcResponse?.data) {
              servicesForMatching = svcResponse.data;
              setServices(svcResponse.data);
            }
          } catch (e) {
            console.log("err fetching services for booking's partner----", e);
          }

          let selectedId;
          for (let i of servicesForMatching) {
            if (i.id === service_id) {
              selectedId = service_id;
              setSelectedService(i);
            }
          }
          let q1 = `getWokerAvailableSlots?date=${service_date}`;
          if (selectedId) {
            q1 += `&&service_id=${selectedId}`;
          }
          // setLoading(true);
          let getWorkerAvailable = await apicall.get(q1);
  
          let updatedData = getWorkerAvailable?.data || [];
  
          setInitialAppointments(getWorkerAvailable?.data || []);

          // Same slot-derived doctor list used everywhere else now (see
          // getWorkerAvailableSlots) — ensures the booking's already-assigned
          // doctor (in `providers`) is present in the options the MultiSelect
          // reconciliation effect matches against.
          const editDoctorMap = new Map();
          for (let slot of updatedData) {
            const providerId = slot?.extendedProps?.provider_id;
            if (providerId && !editDoctorMap.has(providerId)) {
              editDoctorMap.set(providerId, {
                id: providerId,
                serviceProvider_id: providerId,
                user_id: providerId,
                name: slot?.title || slot?.extendedProps?.search || `Doctor ${providerId}`,
              });
            }
          }
          setDoctors(Array.from(editDoctorMap.values()));

          let dt = `${service_date}T${service_time}:00`;
          // console.log("dt---", dt);
  
          let p1 = [];
          for (let i of providers) {
            for (let j of updatedData) {
              if (i === j?.extendedProps?.provider_id && dt === j.start) {
                j.status = 2;
                p1.push(j);
              }
            }
          }
          // console.log("p1---", p1);
          setProviderSelected(p1);
  
          if (!editable) {
            let ans = updatedData.filter((i) => {
              let hours = timeSelect.split(":")[0];
              let mins = timeSelect.split(":")[1];
  
              let res = i.start.split("T")?.[1];
              // console.log(
              //   "res--",
              //   res,
              //   `${hours}:${mins}:00`,
              //   res === `${hours}:${mins}:00`
              // );
              return res === `${hours}:${mins}:00`;
              //   if (res === `${hours}:${mins}:00`) {
              //   i.start = i.start.split("T")[0] + "T" + `${hours}:${mins}:00`;
              // }
            });
            updatedData = ans;
          }
  
          for (let i of updatedData) {
            if (i.status === 2) {
              console.log("i?.start---");
              let date = new Date(i?.start);
              let t1 = maxTime / crewCount;
              date.setMinutes(date.getMinutes() + t1);
              i.end = convertWithoutTimseStamp(date);
            }
          }
          let u1 = cleanCrewSlots(updatedData);
  
          const result = u1.reduce(
            (acc, item) => {
              return {
                minStart: item.start < acc.minStart ? item.start : acc.minStart,
                maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
              };
            },
            {
              minStart: u1[0].start,
              maxEnd: u1[0].end,
            }
          );
          let min1 = result?.minStart?.split?.("T")?.[1];
          let max1 = result?.maxEnd?.split?.("T")?.[1];
          setTimeRange({
            startTime: `2026-04-09T${min1}`,
            endTime: `2026-04-09T${max1}`,
          });
  
          setFilteredAppointments(u1 || []);
        } else {
        }
      } catch (e) {
        console.log("e----", e);
      } finally {
        setLoading(false);
      }
    }

    // Deliberately no async re-fetch of currency here (unlike an earlier
    // version of this effect) — react-phone-input-2 silently drops its
    // "+91"/"+971" prefix display when the `country` prop changes AFTER
    // mount instead of being correct from the very first render (see the
    // `currency` useState initializer above, and the same note on
    // AddProvider.jsx, which never re-fetches currency post-mount either).
    // localStorage's "currency" is already correct here — this component
    // doesn't need a second, later-arriving source that could flip it.
// const get_services = async () => {
//   try {
//     const response = await apicall.get("get_ezp_service");
//     if (response.status === 200) {
//       const list = response.data.map((s) => ({
//         id: s.service_id,
//         name: s.service_name,
//       }));
//       setServices(list);
//     }
//   } catch (err) {
//     console.error(err);
//   }
// };
  useEffect(() => {
    getAllServices();
  }, [partner_id]);

  // Restore form when reopened from Checkout ("Back" / "+ Add Item").
  // Checkout renders this component inline as a sidepanel and passes the
  // saved values directly via `checkoutReturnValues` (no navigation, no
  // page-context change) — the route-state path only covers the standalone
  // /new-appointment page being reloaded directly with that state.
  useEffect(() => {
    const state = routeLocation.state;
    const bv = checkoutReturnValues || (state?.checkoutReturn ? state?.bookingValues : null);
    if (!bv) return;

    formikRef.current?.setValues({
      ...(formikRef.current?.values || {}),
      ...bv,
    });

    if (bv.date) setDateSelect(bv.date);
    if (bv.time) setTimeSelect(bv.time);
    if (bv.paid_amount !== undefined) setPaidAmount(bv.paid_amount);
    if (bv.partner) setPartner_id(bv.partner);
    // Back / "+ Add Item" from Checkout: keep the room that was picked.
    if (bv.resource_ids !== undefined) {
      setResourceIds(String(bv.resource_ids || ""));
    }

    if (bv.serviceData?.length > 0) {
      checkoutReturnServiceDataRef.current = bv.serviceData;
      const offeringIds = bv.serviceData
        .filter((s) => s.added)
        .map((s) => s.service_offering_id);
      setSelectedOfferings(offeringIds);
      const addedItem = bv.serviceData.find((s) => s.added);
      if (addedItem?.service_type_name) setActiveType(addedItem.service_type_name);
    }
    if (bv.priceSection) setPriceSection(bv.priceSection);

    // Trigger the Specialization lookup so fetchServiceData (using the ref
    // above) runs against the right service object once `services` loads.
    if (bv.specialization && services.length > 0) {
      const svc = services.find((s) => s.service_id === bv.specialization);
      if (svc) setSelectedService(svc);
    }

    if (!checkoutReturnValues) window.history.replaceState({}, "");
  }, [checkoutReturnValues, routeLocation.state, services]);
    const crewCount = providerSelected?.length || 0;

  function convertWithoutTimseStamp(date) {
    try {
      const year = date?.getFullYear();
      const month = String(date?.getMonth() + 1).padStart(2, "0");
      const day = String(date?.getDate()).padStart(2, "0");
      const hours = String(date?.getHours()).padStart(2, "0");
      const minutes = String(date?.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    } catch (e) {
      console.log("err---", date, e);
    }
  }
  async function getAllServices() {
    const requestId = ++latestRequestRef.current;

    try {
      setLoading(true);
      setServicesLoaded(false);

      const response = await apicall.get(
        `get_ezp_service?partner_id=${partner_id}`
      );
      console.log(response,"response")

      // ❗ Ignore if not latest call
      if (requestId !== latestRequestRef.current) return;

      if (response.success && response.data) {
        setServices(response.data);

        if (group_id) {
          getDataByID(response.data);
        } else if (response.data.length > 0) {
          // No auto-selected default Specialization for a fresh appointment
          // — the user picks one themselves. Auto-selecting here was also
          // the source of the "doctor not showing for the default
          // Specialization" race (selectedService/values.specialization
          // updating asynchronously before other effects had caught up).

          // setInitialValues({
          //   partner: partner_id,
          //   org_id: "",
          //   userName: "",
          //   phoneNumber: "",
          //   email: "",
          //   house_no: "",
          //   area: "",
          //   location: "",
          //   location_id: "",
          //   state: "",
          //   landmark: "",
          //   country: 1,
          //   lat: "",
          //   lng: "",
          //   status: "",
          //   payment: "",
          // });
        } else {
          // This profile has zero services configured — clear out whatever
          // Specialization/Specialization Type was left over from a
          // previously selected profile instead of leaving stale data shown.
          setSelectedService(null);
          setServiceData([]);
          setServiceDataLoaded(true);
          formikRef.current?.setFieldValue("specialization", "");
          formikRef.current?.setFieldValue("specialization_type", []);
          setDoctors([]);
        }
      } else {
        setServices([]);
        setSelectedService(null);
        setServiceData([]);
        setServiceDataLoaded(true);
        formikRef.current?.setFieldValue("specialization", "");
        formikRef.current?.setFieldValue("specialization_type", []);
        setDoctors([]);
      }
    } catch (e) {
      console.log("e----", e);
      setServices([]);
    } finally {
      // Only stop loading for latest request
      if (requestId === latestRequestRef.current) {
        setLoading(false);
        setServicesLoaded(true);
      }
    }
  }
const addOffering = (data) => {
  let id = data.service_offering_id;

  let updated = selectedOfferings.includes(id)
    ? selectedOfferings.filter(i => i !== id)
    : [...selectedOfferings, id];

  setSelectedOfferings(updated);

  setServiceData(prev =>
    prev.map(item => ({
      ...item,
      added: updated.includes(item.service_offering_id)
    }))
  );
};
    useEffect(() => {
      arrangeData();
    }, [serviceData]);

function arrangeData() {
  setServiceTypes([]); // no types
  setGroupedData({ all: serviceData }); // single group
}
  // Form validation schema

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

const debouncedCheckUserExists = useCallback(
  debounce((value, setFieldValue, setFieldTouched) => {
    if (value.length >= 10) {
      get_user_details(value, setFieldValue, setFieldTouched);
    }
  }, 500),
  []
);


const get_user_details = async (ph_number, setFieldValue, setFieldTouched) => {
  try {
    if(!ph_number){
      toast.error("Please enter  valid Mobile number");
      return;
    }
    // New combined lookup (customer + their dependents sharing this number)
    // — separate endpoint from ezp_get_users_details, which other flows
    // already depend on and which this deliberately leaves untouched.
    const response = await apicall.get(
      `ezp_get_customer_with_dependents/${ph_number}/${vendorId}`
    );

    const user = response?.data?.customer;
    const dependents = response?.data?.dependents || [];

    if (response.status === 200 && user) {
      const fullName = `${user.first_name} ${user.middle_name || ""} ${user.last_name || ""}`.trim();

      // Gender Dropdown options use numeric values (1/2) — see the same fix
      // in getDataByID for why a string here left the field showing blank.
      const gender =
        Number(user.gender) === 1 ? 1 : Number(user.gender) === 2 ? 2 : "";

      setUser_id(user?.id || 0);

      const options = [
        { id: user.id, name: fullName, isCustomer: true, gender: user.gender, dob: user.dob },
        ...dependents.map((d) => ({ id: d.id, name: d.name, isCustomer: false, gender: d.gender, dob: d.dob })),
      ];
      setDependentOptions(options);
      setSelectedPersonId(user.id);
      setAddingNewPerson(false);

      setFieldValue("patientName", fullName);
      // This is an automatic fill, not something the user typed/erased —
      // if a previous lookup on this same field had already marked it
      // touched (e.g. an earlier number with no match), that stale touched
      // flag would make "Patient name is required" render immediately even
      // though the field now legitimately holds this name.
      setFieldTouched("patientName", false, false);
      setFieldValue("age", user.dob ? new Date().getFullYear() - new Date(user.dob).getFullYear() : "");
      setFieldValue("gender", gender);

      setFieldValue("house_no", user?.house_no || "");
      setFieldValue("area", user?.area || "");
      setFieldValue("landmark", user?.landmark || "");
      setFieldValue("state", user?.state || "");
      setFieldValue("location", user?.location || "");
      setFieldValue("lat", user?.lat || "");
      setFieldValue("lng", user?.lng || "");

      let d1 = {
        house_no: user?.house_no || "",
        area: user?.area || "",
        location: user?.location || "",
        state: user?.state || "",
        landmark: user?.landmark || "",
        lat: user?.lat || "",
        lng: user?.lng || "",
      };

      setFirstLocation(d1);

    } else {
      // No customer found for this number at all — brand new, unchanged.
      setDependentOptions([]);
      setSelectedPersonId(null);
      setAddingNewPerson(false);
      setFieldValue("patientName", "");
      setFieldValue("age", "");
      setFieldValue("gender", "");
      toast.info("No customer found with this number — continue below to add them as a new patient.");
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to fetch user details");
  }
};
  const fetchDoctors = async (page = 1, isLoadingMore = false, specializationId = "") => {
    try {
      if (page === 1) {
        setLoadingDoctors(true);
      }

      let url = `get_service_providers?vendor_id=${vendorId}&role=3&limit=${DOCTORS_PER_PAGE}&page=${page}`;

      if (specializationId) {
        url += `&specilisation=${specializationId}`;
      }

      if (doctorSearchTerm && doctorSearchTerm.trim() !== '') {
        url += `&name=${encodeURIComponent(doctorSearchTerm.trim())}`;
      }

      const response = await apicall.get(url);
      console.log("fetchDoctors response:", response);

      if (response.status === 200) {
        const formattedDoctors = response.data.map(doctor => ({
          id: doctor.id,
          serviceProvider_id: doctor?.service_provider,
          user_id: doctor.user_id,
          name: `${doctor.first_name} ${doctor.last_name || ''}`.trim(),
          specialization: doctor.specilisation
        }));

        if (page === 1) {
          setDoctors(formattedDoctors);
        } else {
          setDoctors(prev => [...prev, ...formattedDoctors]);
        }

        setHasMoreDoctors(formattedDoctors.length === DOCTORS_PER_PAGE);
        setDoctorPage(page);
      }
    } catch (error) {
      console.error('Error fetching doctors:', error);
      toast.error('Failed to fetch doctors');
    } finally {
      setLoadingDoctors(false);
    }
  };

  // `doctors` is already scoped to the selected Specialization + date — it's
  // populated straight from getWokerAvailableSlots (see getWorkerAvailableSlots
  // / getDataByID), the same source Bookings.jsx uses for its crew list,
  // instead of a separate get_service_providers lookup. Nothing further to
  // filter here; this just requires a Specialization to have been chosen.
  const getFilteredDoctors = (specializationId) => {
    if (!specializationId) return [];
    return doctors;
  };

  // Fetch insurance providers on component mount
  useEffect(() => {
    const fetchInsuranceProviders = async () => {
      try {
        const response = await apicall.get('insurance-providers');
        if (response) {
          setInsuranceProviders(response.data);
          setInsuranceProvidersLoaded(true);
        }
      } catch (error) {
        toast.error('Failed to fetch insurance providers');
        setInsuranceProvidersLoaded(true);
      }
    };

    fetchInsuranceProviders();

  }, []);
const providerHelp = {
  payment: isClinicService
    ? HELP_CONTENT.bookings.DoctorpaymentStatus
    : HELP_CONTENT.bookings.paymentStatus
}
  // Doctors ("Crew") for an edit-mode booking can only be matched to the
  // MultiSelect's `doctors` field once the crew list has loaded — which may
  // not have happened yet by the time getDataByID resolves. Reconcile the two
  // whenever either becomes available, same as the calendar-slot matching
  // already does for providerSelected.
  //
  // This must only apply the ORIGINAL booking's doctor once. `doctors`
  // (the options list) gets a fresh array reference every time the user
  // picks a different doctor too (each selection re-fetches slots), which
  // re-triggered this effect and stomped the user's new pick straight back
  // to the original bookingProviderIds — selecting a doctor appeared to
  // instantly revert to "Select Doctor".
  const doctorReconciledRef = useRef(false);
  useEffect(() => {
    if (doctorReconciledRef.current) return;
    if (!bookingProviderIds || bookingProviderIds.length === 0 || doctors.length === 0) return;
    const matchedDoctors = doctors.filter((d) =>
      bookingProviderIds.includes(d.serviceProvider_id)
    );
    if (matchedDoctors.length === 0) return;
    doctorReconciledRef.current = true;
    formikRef.current?.setFieldValue("doctors", matchedDoctors.map((d) => d.id));
    formikRef.current?.setFieldValue(
      "providers",
      matchedDoctors.map((d) => d.serviceProvider_id)
    );
  }, [doctors, bookingProviderIds]);

  // Handle click outside for dropdowns
  useEffect(() => {
    function handleClickOutside(event) {
      if (insuranceProviderRef.current && !insuranceProviderRef.current.contains(event.target)) {
        setShowInsuranceProviderDropdown(false);
      }
      if (timeSlotRef.current && !timeSlotRef.current.contains(event.target)) {
        setShowTimeDropdown(false);
      }
      if (doctorDropdownRef.current && !doctorDropdownRef.current.contains(event.target)) {
        setShowDoctorDropdown(false);
      }
      if (patientNameRef.current && !patientNameRef.current.contains(event.target)) {
        setShowPatientNameDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

const getWorkerAvailableSlots=async(date, serviceIdOverride, doctorIdOverride)=>{
  // if (!providerIds?.?ength || !date) return;
  const requestId = ++latestSlotsRequestRef.current;

  try {
    let d1 = new Date(date);
    d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;

    let q1 = `getWokerAvailableSlots?date=${d1}`;

      // Accept an explicit service id so callers that just called
      // setSelectedService(...) in the same handler don't hit a stale
      // `selectedService` closure (state updates aren't applied yet at
      // that point in the same synchronous block). Prefer the live Formik
      // value over `selectedService` state as the fallback too — on a fresh
      // page load, getAllServices() auto-selecting the first Specialization
      // is async, so a date picked quickly after mount could otherwise race
      // ahead of `selectedService` and silently query with no service_id at
      // all (the backend then falls back to service_id=0, matching nobody).
      const effectiveServiceId =
        serviceIdOverride ?? formikRef.current?.values?.specialization ?? selectedService?.service_id;
      if (!effectiveServiceId || effectiveServiceId === "undefined") {
        setDoctors([]);
        setAvailableTimeSlots([]);
        return;
      }
      q1 += `&&service_id=${effectiveServiceId}`;
      let getWorkerAvailable = await apicall.get(q1);
console.log(getWorkerAvailable,"getWorkerAvailable")

    // Ignore this response if a newer call (e.g. the user changed
    // Specialization/Doctor/date again while this was in flight) has already
    // started — without this, a slow earlier request could resolve after a
    // newer one and silently clobber the doctors/slots it just set.
    if (requestId !== latestSlotsRequestRef.current) return;

    let updatedData = JSON.parse(JSON.stringify(getWorkerAvailable?.data || []));

    setInitialAppointments(updatedData);

    // Same source Bookings.jsx uses for crew: whoever has a generated slot
    // here (getWokerAvailableSlots, shift-based) is who's actually offered
    // for this Specialization + date — not a separate get_service_providers
    // lookup, which relies on a `specilisation`/`service` column that isn't
    // reliably populated the same way across every "add doctor" flow. Date
    // now comes before Doctor Name in the form, so this is always available
    // by the time the user reaches the doctor field.
    const doctorMap = new Map();
    for (let slot of updatedData) {
      const providerId = slot?.extendedProps?.provider_id;
      if (providerId && !doctorMap.has(providerId)) {
        doctorMap.set(providerId, {
          id: providerId,
          serviceProvider_id: providerId,
          user_id: providerId,
          name: slot?.title || slot?.extendedProps?.search || `Doctor ${providerId}`,
        });
      }
    }
    setDoctors(Array.from(doctorMap.values()));

    // Time slots shown below must belong to the SELECTED doctor only —
    // otherwise every doctor's availability for this service+date gets
    // merged together (doctor A's 8am-7pm next to doctor B's 8am-9am, all
    // shown at once).
    const selectedDoctorId = doctorIdOverride !== undefined
      ? doctorIdOverride
      : formikRef.current?.values?.doctors?.[0];
    updatedData = selectedDoctorId
      ? updatedData.filter((slot) => slot?.extendedProps?.provider_id === selectedDoctorId)
      : [];

    for (let i of providerSelected || []) {
      for (let j of updatedData) {
        if (
          i?.start === j?.start &&
          i.extendedProps?.provider_id === j.extendedProps?.provider_id
        ) {
          j.status = 2;

          let date = new Date(j.start);
          date.setMinutes(date.getMinutes() + maxTime);
          j.end = date;
        }
      }
    }

    let updated = [];

    for (let i of updatedData) {
      let flag = true;

      if ([2, 3].includes(i.status)) {
        updated.push(i);
      } else {
        for (let j of providerSelected || []) {
          let s1 = new Date(i.start);
          let e1 = new Date(i.end);
          let p1 = i.extendedProps?.provider_id;

          let s2 = new Date(j.start);
          let e2 = new Date(j.end);
          let p2 = j.extendedProps?.provider_id;

          if (p1 === p2 && s1 >= s2 && e1 <= e2) {
            flag = false;
            break;
          }
        }

        if (flag) {
          updated.push(i);
        }
      }
    }

    for (let i of updated) {
      if (i.status === 2) {
        let date = new Date(i.start);
        let t1 = maxTime / (crewCount || 1);
        date.setMinutes(date.getMinutes() + t1);
        i.end = date;
      }
    }


    let cleaned = cleanCrewSlots(updated);

    if (cleaned.length > 0) {
      const result = cleaned.reduce(
        (acc, item) => ({
          minStart: item.start < acc.minStart ? item.start : acc.minStart,
          maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
        }),
        {
          minStart: cleaned[0].start,
          maxEnd: cleaned[0].end,
        }
      );

      let min1 = result.minStart.split("T")[1];
      let max1 = result.maxEnd.split("T")[1];

      setTimeRange({ startTime: min1, endTime: max1 });
    }
    setFilteredAppointments(cleaned);

    const slots = cleaned.map((item) => {
      const start = new Date(item.start);
      const end = new Date(item.end);

      const format = (date) => date.toTimeString().slice(0, 5);

      return `${format(start)} - ${format(end)}`;
    });
    setAvailableTimeSlots(slots);

  } catch (e) {
    console.log("error fetching doctor slots", e);
  }
};

useEffect(() => {
  if (formValues?.appointmentDate){
    getWorkerAvailableSlots(formValues?.appointmentDate, undefined, formValues?.doctors?.[0])
  }
// Also re-run once Specialization becomes available — getAllServices()
// auto-selects the first Specialization asynchronously, so a date picked
// right after the page opens can otherwise race ahead of it.
}, [formValues?.appointmentDate, formValues?.specialization])

useEffect(() => {
   if (formValues?.doctors?.length > 0 && formValues?.appointmentDate){
    getWorkerAvailableSlots(formValues.appointmentDate, undefined, formValues.doctors[0])
  }
  // if (values.doctors?.length && values.appointmentDate) {
  //   getWorkerAvailableSlots(values.appointmentDate);
  // }
}, [formValues?.doctors]);

 const isTodayAppointment = () => {
    if (!bookedDate) return false;
    const today = new Date().toISOString().split('T')[0];
    return bookedDate === today;
  };

  const checkAppointmentTimePassed = () => {
    if (!bookedDate || !appointmentTimeState) {
      setTimeSlotsPassed(false);
      return false;
    }

    const today = new Date();
    const appointmentDate = new Date(bookedDate);

    if (today.toISOString().split('T')[0] !== bookedDate) {
      setTimeSlotsPassed(false);
      return false;
    }

    const timeSlots = appointmentTimeState.includes(',')
      ? appointmentTimeState.split(',')
      : [appointmentTimeState];

    const allPassed = timeSlots.every(slot => {
      const trimmedSlot = slot.trim();
      const [time, modifier] = trimmedSlot.split(' ');
      if (!time || !modifier) return false;

      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);
      minutes = parseInt(minutes, 10);

      if (modifier.toUpperCase() === 'PM' && hours < 12) hours += 12;
      if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

      const slotTime = new Date(appointmentDate);
      slotTime.setHours(hours, minutes + 15, 0, 0);

      return today > slotTime;
    });

    setTimeSlotsPassed(allPassed);
    return allPassed;
  };

  useEffect(() => {
    if (isTodayAppointment() && !noShowMarked && currentStatus !== 15) {
      checkAppointmentTimePassed();
      const interval = setInterval(checkAppointmentTimePassed, 60000);
      return () => clearInterval(interval);
    }
  }, [isTodayAppointment(), appointmentTimeState, noShowMarked, currentStatus]);

  const isPastAppointment = () => {
    if (!bookedDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const appointmentDate = new Date(bookedDate);
    return appointmentDate < today;
  };

  const isFutureAppointment = () => {
    if (!bookedDate) return false;
    const today = new Date();
    const appointmentDate = new Date(bookedDate);
    return appointmentDate > today;
  };

  const canCheckIn = isTodayAppointment() && currentStatus !== 11 && currentStatus !== 15 && !noShowMarked;
  const canCheckOut = isTodayAppointment() && currentStatus === 11 && !noShowMarked;
  // const canNoShow = ((isTodayAppointment() && timeSlotsPassed) || isPastAppointment()) && !noShowMarked;
  // const noShowDisabled = !canNoShow || isFutureAppointment() || currentStatus === 15 || noShowMarked;
  const canNoShow = ((isTodayAppointment() && timeSlotsPassed) || isPastAppointment()) && !noShowMarked && currentStatus !== 11;
  // Update the noShowDisabled to include currentStatus === 11
  const noShowDisabled = !canNoShow || isFutureAppointment() || currentStatus === 15 || noShowMarked || currentStatus === 11;

  //api function to fetch available slots



useEffect(() => {
  if (
    insuranceProvidersLoaded &&
    initialData?.details?.insurance_provider &&
    formikRef.current
  ) {
    // insuranceProvider Dropdown options use numeric values (p.insurance_provider_id,
    // an INT column) — the saved booking's insurance_provider comes back as a
    // string (VARCHAR column), so it never matched any option without this
    // conversion, same mismatch as the Gender field above.
    formikRef.current.setFieldValue(
      "insuranceProvider",
      Number(initialData.details.insurance_provider)
    );
  }
}, [insuranceProvidersLoaded, initialData]);

useEffect(() => {
  const formValues = formikRef.current?.values;

  if (formValues?.appointmentTime) {
    setAppointmentTimeState(formValues.appointmentTime);
    checkAppointmentTimePassed();
  }
}, [formikRef.current?.values?.appointmentTime]);

  const handleYesClick = () => {
    setFollowUpConfirm(false)
    setShowModal(true);

  };

  const handleModalClose = () => {
    setShowModal(false);
    onClose();
  };

  const handleDelete = () => {
    setShowDeleteConfirm(true);
  };

  const isViewMode = mode === 'view';
  const isEditMode = mode === 'edit';

const handleTimeSlotClick = (slot) => {
  const formValues = formikRef.current?.values;
  if (!formValues) return;

  const currentSlots = formValues.selectedTimeSlots || [];
  const startTime = slot.split(" - ")[0].trim();

  // Single-select: picking a slot replaces whatever was selected before
  // (only the first selectedTimeSlots entry is ever submitted, see values.time
  // above); clicking the already-selected slot again clears the selection.
  const newSlots = currentSlots.includes(startTime) ? [] : [startTime];

  const formattedTimes = newSlots
    .map((time) => {
      const [hourStr, minute] = time.split(":");
      const hour = parseInt(hourStr, 10);
      return `${hour < 10 ? "0" + hour : hour}:${minute}`;
    })
    .join(", ");

  formikRef.current.setFieldValue("selectedTimeSlots", newSlots);
  formikRef.current.setFieldValue("appointmentTime", formattedTimes);

  setAppointmentTimeState(formattedTimes);

  // Close the picker on selection, same single-choice behavior as the
  // Gender/Specialization dropdowns (pick one and it's done).
  if (newSlots.length > 0) {
    setShowTimeDropdown(false);
  }
};

  const convertTo24HourFormat = (slots) => {
    return slots.map(slot => {
      const strSlot = String(slot).trim();
      const [time, modifier] = strSlot.split(' ');
      if (!time || !modifier) return null;

      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);
      if (modifier.toUpperCase() === 'PM' && hours < 12) hours += 12;
      if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }).filter(Boolean);
  };

const handleRescheduleAppointment = async (statusUpdate) => {
  const formValues = formikRef.current?.values;
  if (!formValues) return;

  const formattedSlot = convertTo24HourFormat(
    formValues.selectedTimeSlots || []
  );

  let statusPayload;
  switch (statusUpdate) {
    case 'No show':
      statusPayload = { status: 12 };
      setNoShowMarked(true);
      break;
    case 'check in':
      statusPayload = { status: 11 };
      break;
    case 'check out':
      statusPayload = { status: 15 };
      break;
    default:
      statusPayload = {};
  }

  const payload = {
    booking_id: bookingId,
    appointment_date: formValues.appointmentDate,
    time_slots:
      (formValues.selectedTimeSlots || []).length === 0
        ? convertTo24HourFormat([formValues.appointmentTime])
        : formattedSlot,
    user_id: userId,
    insurance_number: formValues.insuranceNumber,
    insurance_provider: formValues.insuranceProvider,
    ...statusPayload,
  };

  try {
    const response = await apicall.post(payload, 'update-booking');

    if (response.status === 200) {
      const messages = {
        'No show': 'Appointment marked as No Show successfully',
        'check in': 'Appointment checked in successfully',
        'check out': 'Appointment checked out successfully',
        'reschedule': 'Appointment Rescheduled successfully',
      };

      toast.success(messages[statusUpdate], {
        autoClose: 1500,
        onClose: () => {
          if (statusUpdate !== 'check out') {
            window.location.reload();
          }
        }
      });

      setCurrentStatus(statusPayload.status || currentStatus);

      if (statusUpdate !== 'check out') {
        onClose();
      } else {
        setFollowUpConfirm(true);
      }
    }

  } catch (error) {
    toast.error('Failed to update appointment');

    if (statusUpdate === 'No show') {
      setNoShowMarked(false);
    }
  }
};
    console.log(loadingDoctors,"loadingDoctors")


  const handleCheckIn = () => handleRescheduleAppointment("check in");
  const handleNoShow = () => {
    setShowNoShowConfirm(false);
    handleRescheduleAppointment("No show");
  };
  const handleCheckout = () => handleRescheduleAppointment("check out");
  const handleReScheduleRedirect = () => {
    onClose('edit');
    setShowNoShowConfirm(false);
  };

  return (
       <div className="appointment-form">
<Formik
  innerRef={formikRef}
  initialValues={initialValues}
  validationSchema={validationSchema}
  onSubmit={onSubmitFormn}
  enableReinitialize={true}
>
      {({
       values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setValues,
            setFieldError,
            setFieldTouched,
      }) => {
       return(
      <Form onSubmit={handleSubmit}>
        {group_id && editDisplayBookingId && (
          <h5 className="mb-3">Edit Appointment - {editDisplayBookingId}</h5>
        )}
        {/* Patient Information Section */}
                   <div className="mb-3">
          <Form.Group>
                                        <Form.Label>Profile <FieldHelpTooltip {...HELP_CONTENT.newAppointment.partner} /></Form.Label>
                                        <Dropdown
                                          name="partner"
                                          value={values.partner || null}
                                          options={partners?.map((partner) => ({
                                            label: partner?.partner_name,
                                            value: partner?.id,
                                          }))}
                                          placeholder="Select Profile"
                                          onChange={(e) => {
                                            handleChange({
                                              target: { name: "partner", value: e.value },
                                            });
                                            // getAllServices() (triggered by the partner_id effect below)
                                            // already re-fetches this profile's services and refreshes
                                            // serviceData/selectedService correctly. Calling
                                            // fetchServiceData here too — with the *old* profile's
                                            // stale `selectedService` closure — was racing that call
                                            // and could leave the Specialization Type list showing the
                                            // previous profile's data.
                                            setPartner_id(e.value);
                                          }}
                                          onBlur={handleBlur}
                                          disabled={isEditMode || isViewMode}
                                          className={`w-100 ${
                                            touched.partner && errors.partner ? "is-invalid" : ""
                                          }`}
                                          style={{
                                            height: "40px",
                                            backgroundColor: "white",
                                            border:
                                              touched.partner && errors.partner
                                                ? "1px solid #dc3545"
                                                : "1px solid #E9ECEF",
                                          }}
                                        />

                                        {touched.partner && errors.partner && (
                                          <div className="invalid-feedback d-block">
                                            {errors.partner}
                                          </div>
                                        )}
                                      </Form.Group>
                                      </div>

           <div className="mb-3">
 <Form.Label>
   Mobile Number
   <FieldHelpTooltip {...HELP_CONTENT.newAppointment.mobileNumber} />
 </Form.Label>
  <div style={{ position: "relative" }}>
    <PhoneInput
      // Same pattern as AddProvider.jsx, which renders the "+91"/"+971"
      // prefix correctly — currency is now resolved synchronously (see
      // useState initializer above) so this is correct from first mount.
      // Once a real number is already loaded (edit mode via getDataByID),
      // key off its own dial code instead so this prop doesn't flip back
      // and forth and reformat/wipe the loaded value.
      country={
        values.mobileNumber && values.mobileNumber.length > 3
          ? (values.mobileNumber.startsWith('971') ? 'ae' : 'in')
          : phoneCountryIso(currency)
      }
      onlyCountries={['ae', 'in']}
      disableDropdown={true}
      countryCodeEditable={false}
      value={values.mobileNumber}
      onChange={(value) => {
        // react-phone-input-2 can fire onChange on its own (not just from
        // typing) when its `value`/`country` props change programmatically
        // — e.g. right after getDataByID populates this field in edit mode
        // — and it re-formats/re-derives what it thinks the value should
        // be. In edit/view mode this field is never meant to be user-
        // editable anyway, so ignore any onChange there rather than risk
        // it overwriting the loaded number with a reformatted one.
        if (isEditMode || isViewMode) return;
        const cleanedValue = value.replace(/\D/g, '');
        setFieldValue('mobileNumber', cleanedValue);
        setFieldTouched('mobileNumber', true, false);
        // Number is being edited again — clear the previous lookup's
        // self/dependent options so they don't linger for a different number.
        setDependentOptions([]);
        setSelectedPersonId(null);

        // Auto-fetch as soon as the number is actually complete for its
        // country — India 10 local digits, UAE 9 (SUPPORTED_PHONE_COUNTRIES
        // in Constants.js) — instead of requiring the "Fetch Details" button
        // click. Checked against the exact expected local length (not just
        // >= 10) so this fires once, right when the number becomes valid,
        // rather than on every keystroke typed past that point. The button
        // still works too, for re-fetching or if this auto-trigger is missed.
        const expected = getExpectedPhoneCountry(currency);
        const localNumber = cleanedValue.startsWith(expected.dialCode)
          ? cleanedValue.slice(expected.dialCode.length)
          : cleanedValue;
        if (
          localNumber.length === expected.localLength &&
          expected.localPattern.test(localNumber) &&
          lastAutoFetchedMobileRef.current !== cleanedValue
        ) {
          lastAutoFetchedMobileRef.current = cleanedValue;
          debouncedCheckUserExists(cleanedValue, setFieldValue, setFieldTouched);
        }
      }}
      onBlur={() => setFieldTouched('mobileNumber', true)}
      inputStyle={{
        width: '100%',
        height: '40px',
        backgroundColor: '#F8F9FA',
        paddingRight: '110px',
        borderColor: touched.mobileNumber && errors.mobileNumber ? '#dc3545' : undefined,
      }}
      inputProps={{
        name: 'mobileNumber',
        required: true,
        // readOnly instead of the top-level `disabled` prop — react-phone-
        // input-2's `disabled` mode doesn't reliably re-render the masked
        // display text when `value` arrives asynchronously after mount
        // (exactly what happens here: this field mounts empty, then
        // getDataByID's setFieldValue populates the real number once the
        // booking loads) — the field was rendering blank in edit mode even
        // though values.mobileNumber genuinely held the loaded number.
        // readOnly keeps it a normal controlled input (always reflects
        // `value`) while still blocking user edits.
        readOnly: isEditMode || isViewMode,
      }}
    />

    <button
      type="button"
//      onClick={() => {
//   const phone = values.mobileNumber;

//   if (!phone || phone.length < 10) {
//     toast.error("Enter valid mobile number");
//     return;
//   }

//   debouncedCheckUserExists(phone);
// }}
onClick={() => {
  const phone = values.mobileNumber;

  if (!phone || phone.length < 10) {
    toast.error("Enter valid mobile number");
    return;
  }

  debouncedCheckUserExists(phone, setFieldValue, setFieldTouched);
}}
      disabled={isEditMode || isViewMode}
      style={{
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        color: (isEditMode || isViewMode) ? "#adb5bd" : "#dc3545",
        fontSize: "12px",
        fontWeight: "600",
        cursor: (isEditMode || isViewMode) ? "not-allowed" : "pointer",
      }}
    >
      Fetch Details
    </button>
  </div>
  {touched.mobileNumber && errors.mobileNumber && (
    <div className="invalid-feedback d-block">
      {errors.mobileNumber}
    </div>
  )}
</div>
        <div className="mb-3">
          <div className="d-flex align-items-center justify-content-between">
            <Form.Label className="mb-1">
              Patient Name
              <FieldHelpTooltip {...HELP_CONTENT.newAppointment.patientName} />
            </Form.Label>
            {dependentOptions.length > 0 && !addingNewPerson && !isEditMode && !isViewMode && (
              // A plain, always-visible button next to the label — same
              // pattern as "Fetch Details" next to Mobile Number — instead
              // of a row tucked inside the dropdown panel, which read as
              // neither clearly part of the list nor clearly a separate
              // control.
              <button
                type="button"
className="btn btn-link btn-sm p-0 text-danger text-decoration-none d-flex align-items-center gap-1"
                onClick={() => {
                  setAddingNewPerson(true);
                  setFieldValue("patientName", "");
                  setFieldValue("gender", "");
                  setSelectedPersonId(null);
                  // Cleared programmatically, not by the user typing/erasing
                  // — don't mark it touched, so "Patient name is required"
                  // doesn't flash before they've had a chance to type
                  // anything into the now-empty field.
                  setFieldTouched("patientName", false, false);
                  setShowPatientNameDropdown(false);
                }}
              >
                <FaPlus size={11} /> Add
              </button>
            )}
          </div>
          {dependentOptions.length > 0 && !addingNewPerson ? (
            // Pick yourself or an existing family member booked under the
            // same number before. This is a closed, click-to-select list —
            // the field itself is never typed into — so switching to a
            // different family member always shows every option instead of
            // silently filtering some out based on leftover typed text.
            // Adding someone new is a separate, explicit action (the
            // "+ Add Family Member / Friend" button next to the label above)
            // rather than backspacing over whichever name happens to be
            // pre-filled.
            // Built on PrimeReact's own p-dropdown/p-dropdown-panel/
            // p-dropdown-item classNames (same theme CSS already styling
            // Specialization/Gender/Doctor below) so it's visually identical
            // to those.
            <div
              ref={patientNameRef}
              className={`p-dropdown p-component p-inputwrapper w-100 ${touched.patientName && errors.patientName ? "is-invalid" : ""}`}
              style={{
                height: "40px",
                position: "relative",
                border:
                  touched.patientName && errors.patientName
                    ? "1px solid #dc3545"
                    : "1px solid #E9ECEF",
              }}
            >
              <input
                type="text"
                name="patientName"
                autoComplete="off"
                readOnly
                className="p-dropdown-label p-inputtext"
                style={{ cursor: isEditMode || isViewMode ? "not-allowed" : "pointer", backgroundColor: "white" }}
                value={values.patientName}
                onFocus={() => setShowPatientNameDropdown(true)}
                onClick={() => setShowPatientNameDropdown(true)}
                placeholder="Select a patient"
                disabled={isEditMode || isViewMode}
              />
              {!isEditMode && !isViewMode && (
                <div
                  className="p-dropdown-trigger"
                  onClick={() => setShowPatientNameDropdown((v) => !v)}
                >
                  <FaChevronDown className="p-dropdown-trigger-icon p-clickable" size={12} />
                </div>
              )}
              {showPatientNameDropdown && !isEditMode && !isViewMode && (
                <div
                  className="p-dropdown-panel p-component"
                  style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 10 }}
                >
                  <div className="p-dropdown-items-wrapper" style={{ maxHeight: "200px" }}>
                    <ul className="p-dropdown-items">
                      {dependentOptions.map((o) => (
                        <li
                          key={o.id}
                          className={`p-dropdown-item ${o.id === selectedPersonId ? "p-highlight" : ""}`}
                          onMouseDown={() => {
                            setFieldValue("patientName", o.name);
                            setSelectedPersonId(o.id);
                            setFieldTouched("patientName", true, false);
                            setShowPatientNameDropdown(false);
                            // Each person under this mobile number (the
                            // customer or one of their dependents) can have
                            // a different gender — switching who this
                            // appointment is for must switch the Gender
                            // field to that person's own value instead of
                            // leaving whichever one was fetched first.
                            const selectedGender =
                              Number(o.gender) === 1 ? 1 : Number(o.gender) === 2 ? 2 : "";
                            setFieldValue("gender", selectedGender);
                            setFieldValue(
                              "age",
                              o.dob ? new Date().getFullYear() - new Date(o.dob).getFullYear() : ""
                            );
                          }}
                        >
                          <span>{o.isCustomer ? `${o.name}` : o.name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : dependentOptions.length > 0 && addingNewPerson ? (
            // New-name entry mode, reached only via "+ Add Family Member"
            // above. Backing out returns to the found customer rather than
            // leaving the field blank.
            <div>
              <div className="d-flex align-items-center gap-2">
                <Form.Control
                  type="text"
                  name="patientName"
                  autoFocus
                  placeholder="Enter family member / friend's name"
                  value={values.patientName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={isEditMode || isViewMode}
                  className={`w-100 ${touched.patientName && errors.patientName ? "is-invalid" : ""}`}
                  style={{
                    height: "40px",
                    backgroundColor: "white",
                    border:
                      touched.patientName && errors.patientName
                        ? "1px solid #dc3545"
                        : "1px solid #E9ECEF",
                  }}
                />
                {!isEditMode && !isViewMode && (
                  <button
                    type="button"
                    className="btn text-danger btn-sm text-nowrap px-0"
                    onClick={() => {
                      setAddingNewPerson(false);
                      const self = dependentOptions.find((o) => o.isCustomer);
                      setFieldValue("patientName", self?.name || "");
                      setFieldValue("gender", "");
                      setSelectedPersonId(self?.id || null);
                      // Reverting programmatically to the known-good default
                      // — clear touched so a stale "required" error can't
                      // linger from whatever was typed in Add mode.
                      setFieldTouched("patientName", false, false);
                    }}
                  >
                    <MdClear/>
                  </button>
                )}
              </div>
            </div>
          ) : (
            <Form.Control
              type="text"
              name="patientName"
              value={values.patientName}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={isEditMode || isViewMode}
              className={`w-100 ${touched.patientName && errors.patientName ? "is-invalid" : ""}`}
              style={{
                height: "40px",
                backgroundColor: "white",
                border:
                  touched.patientName && errors.patientName
                    ? "1px solid #dc3545"
                    : "1px solid #E9ECEF",
              }}
            />
          )}
          {touched.patientName && errors.patientName && (
            <div className="invalid-feedback d-block">
              {errors.patientName}
            </div>
          )}
        </div>

        {/* Age field hidden for now — not needed currently.
        <div className="mb-3">
          <Form.Label>Age</Form.Label>
          <Form.Control
            type="text"
            name="age"
            value={values.age}
            onChange={handleChange}
            onBlur={handleBlur}
            // disabled={true}
            className='label-bgcolor'
            isInvalid={touched.age && !!errors.age}
          />
          <Form.Control.Feedback type="invalid">
            {errors.age}
          </Form.Control.Feedback>
        </div>
        */}

        <div className="mb-3">
          <Form.Label>Gender <FieldHelpTooltip {...HELP_CONTENT.newAppointment.gender} /></Form.Label>
          <Dropdown
            name="gender"
            value={values.gender || null}
            options={[
              { label: "Male", value: 1 },
              { label: "Female", value: 2 },
            ]}
            placeholder="Select Gender"
            onChange={(e) => setFieldValue("gender", e.value)}
            onBlur={handleBlur}
            disabled={isEditMode || isViewMode}
            className={`w-100 ${
              touched.gender && errors.gender ? "is-invalid" : ""
            }`}
            style={{
              height: "40px",
              backgroundColor: "white",
              border:
                touched.gender && errors.gender
                  ? "1px solid #dc3545"
                  : "1px solid #E9ECEF",
            }}
          />
          {touched.gender && errors.gender && (
            <div className="invalid-feedback d-block">
              {errors.gender}
            </div>
          )}
        </div>

        <div className="mb-3">
          <Form.Label>
            Insurance Number <span>(Optional)</span>
            <FieldHelpTooltip {...HELP_CONTENT.newAppointment.insuranceNumber} />
          </Form.Label>
          <Form.Control
            type="text"
            name="insuranceNumber"
            value={values.insuranceNumber}
            onChange={handleChange}
            disabled={isViewMode}
            style={{ backgroundColor: '#fff' }}
          />
        </div>

        {/* Insurance Provider Dropdown */}
      <div className="mb-3">
  <Form.Label>
    Insurance Provider <span>(Optional)</span>
    <FieldHelpTooltip {...HELP_CONTENT.newAppointment.insuranceProvider} />
  </Form.Label>

  <Dropdown
    name="insuranceProvider"
    value={values.insuranceProvider || null}
    options={insuranceProviders?.map((p) => ({
      label: p.name,
      value: p.insurance_provider_id,
    }))}
    placeholder="Select Insurance Provider"
    onChange={(e) => setFieldValue("insuranceProvider", e.value)}
    onBlur={handleBlur}
    disabled={isViewMode}
    className="w-100"
    style={{
      height: "40px",
      backgroundColor: isViewMode ? "#f8f9fa" : "white",
      border: "1px solid #E9ECEF",
    }}
  />

  <Form.Control.Feedback type="invalid">
    {errors.insuranceProvider}
  </Form.Control.Feedback>
</div>

  <div className="mb-3">
  <Form.Label>Specialization <FieldHelpTooltip {...HELP_CONTENT.newAppointment.service} /></Form.Label>
<Dropdown
  name="specialization"
  value={values.specialization || null}
  options={services.map((service) => ({
    label: service.service_name,
    value: service.service_id,
  }))}
  placeholder="Select Specialization"
  onChange={(e) => {
    const serviceId = e.value;

    setFieldValue("specialization", serviceId);

    // New Specialization — let its own defaults apply again instead of
    // carrying over the "user already picked one" guard from the previous
    // Specialization.
    specializationTypeUserEditedRef.current = false;

    const s = services.find(x => x.service_id === serviceId);
    setSelectedService(s);
    fetchServiceData(s);

    // The previously selected doctor belongs to the old Specialization —
    // clear it rather than leaving a stale/invalid selection in place.
    setFieldValue("doctors", []);
    setFieldValue("providers", []);

    // Refresh doctors (and time slots) for the newly picked Specialization,
    // if a date is already selected — same slot-derived source as everywhere
    // else. Pass serviceId explicitly since selectedService is stale here,
    // and no doctor override since it was just cleared above.
    if (values.appointmentDate) {
      getWorkerAvailableSlots(values.appointmentDate, serviceId, null);
    } else {
      setDoctors([]);
    }
  }}
  onBlur={handleBlur}
  // A booking is for one service — switching Specialization mid-edit would
  // mean editing two different services' bookings at once, which doesn't
  // make sense. Specialization Type below stays editable so the user can
  // still adjust which types under this same service apply.
  disabled={isEditMode || isViewMode}
  className={`w-100 ${
    touched.specialization && errors.specialization ? "is-invalid" : ""
  }`}
  style={{
    height: "40px",
    backgroundColor: "white",
    border:
      touched.specialization && errors.specialization
        ? "1px solid #dc3545"
        : "1px solid #E9ECEF",
  }}
/>

  {touched.specialization && errors.specialization && (
    <div className="invalid-feedback d-block">
      {errors.specialization}
    </div>
  )}

  {servicesLoaded && services.length === 0 && (
    <div className="text-center p-4 border rounded bg-light mt-2">
      <h6 className="text-danger mb-2">No Specialization Available</h6>
      <p className="text-muted mb-0">
        Please add Specialization from Admin Setup to continue booking.
      </p>
    </div>
  )}
</div>

<div className="w-100">
  <Form.Label>Specialization Type <FieldHelpTooltip {...HELP_CONTENT.newAppointment.specializationType} /></Form.Label>

  <Dropdown
    value={values.specialization_type?.[0] ?? null}
    options={serviceData.map((item) => ({
      label: item.service_offering_name,
      value: item.service_offering_id,
    }))}
    placeholder="Select Specialization Type"
     className={`w-100 ${touched.specialization_type && errors.specialization_type ? "is-invalid" : ""}`}
 disabled={isEditMode || isViewMode}
   onChange={(e) => {
  const selectedId = e.value;
  const selectedIds = selectedId != null ? [selectedId] : [];

  // Mark this Specialization's type as user-chosen so a still-in-flight
  // fetchServiceData response can't clobber it back to the default once it
  // resolves (see specializationTypeUserEditedRef above).
  specializationTypeUserEditedRef.current = true;

  setFieldValue("specialization_type", selectedIds).then(() => {
    setFieldTouched("specialization_type", true);
  });
  setSelectedOfferings(selectedIds);

  setServiceData(prev =>
    prev.map(item => ({
      ...item,
      added: selectedIds.includes(item.service_offering_id)
    }))
  );
}}
  />
  {touched.specialization_type && errors.specialization_type && (
    <div className="invalid-feedback d-block">
      {errors.specialization_type}
    </div>
  )}

  {values.specialization && serviceDataLoaded && serviceData.length === 0 && (
    <div className="text-center p-4 border rounded bg-light mt-2">
      <h6 className="text-danger mb-2">No Specialization Types Available</h6>
      <p className="text-muted mb-0">
        Please add specialization Type under the selected Specialization to continue booking.
      </p>
    </div>
  )}
</div>


        {/* Appointment Time Section — comes before Doctor Name: the doctor
            list itself is derived from date-scoped availability slots
            (getWokerAvailableSlots, same source Bookings.jsx uses for crew),
            so the user needs to pick a date before a doctor can be shown. */}
     

 <div className="mb-3">
  <Form.Label>Doctor Name <FieldHelpTooltip {...HELP_CONTENT.newAppointment.provider} /></Form.Label>

  <Dropdown
  value={values.doctors?.[0] || null}
  options={getFilteredDoctors(values.specialization).map((d) => ({
    label: d.name,
    value: d.id,
  }))}
  placeholder="Select Doctor"
  disabled={!values.specialization || !values.appointmentDate  || isViewMode}
  className={`w-100 ${touched.doctors && errors.doctors ? "is-invalid" : ""}`}
onChange={(e) => {
  // A patient can only see one doctor per appointment, so this is a
  // single choice — kept as a 1-item array in Formik state since the
  // submit payload (values.doctors.join(", ")) and the edit-mode
  // reconciliation effect both already expect an array.
  const selectedId = e.value;
  const selectedIds = selectedId ? [selectedId] : [];

  // Chained rather than fired back-to-back: setFieldTouched validates
  // against Formik's current values snapshot, which doesn't yet include this
  // setFieldValue's update when both are called synchronously — that raced
  // "Select doctor" back onto the screen right after a valid pick.
  setFieldValue("doctors", selectedIds).then(() => {
    setFieldTouched("doctors", true);
  });

  const selectedDoctor = doctors.find(d => d.id === selectedId);

  setFieldValue("providers", selectedDoctor ? [selectedDoctor.serviceProvider_id] : []);

  // fetchDoctorSlots(providerIds, values.appointmentDate);
  // getWorkerAvailableSlots only takes a date — the extra providerIds arg was
  // silently becoming the `date` param, corrupting the slot list (see the
  // matching fix above for the full explanation).
  getWorkerAvailableSlots(values.appointmentDate);
}}
/>
  {touched.doctors && errors.doctors && (
    <div className="invalid-feedback d-block">
      {errors.doctors}
    </div>
  )}

  {!values.specialization && (
    <div className="mt-2" style={{ fontSize: '13px' ,color:'#d01c4c'}}>
      Please select a Specialization to view supported doctors.
    </div>
  )}

  {values.specialization && !values.appointmentDate && (
    <div className="text-muted mt-2" style={{ fontSize: '13px' }}>
      Please select an Appointment Date above to view available doctors.
    </div>
  )}

  {values.specialization &&
    values.appointmentDate &&
    getFilteredDoctors(values.specialization).length === 0 && (
      <div className="text-center p-4 border rounded bg-light mt-2">
        <h6 className="text-danger mb-2">No Doctors Available</h6>
        <p className="text-muted mb-0">
          No doctors are available for the selected Specialization on this date. Please add a doctor from Admin Setup or try a different date.
        </p>
      </div>
    )}
</div>
   <div className="mb-4">
          <Form.Label>
            Date &amp; Time
            <FieldHelpTooltip {...HELP_CONTENT.newAppointment.date} />
          </Form.Label>
          <div className="d-flex gap-2">
            <div className="position-relative flex-grow-1">
              <Form.Control
                type="text"
                name="appointmentDate"
                value={values.appointmentDate}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={isEditMode || isViewMode}
                className={isEditMode ? 'bg-white' : 'label-bgcolor'}
                // Bootstrap's isInvalid prop renders its own built-in
                // validation icon at the same right-edge spot as the custom
                // calendar icon below, overlapping it. Apply the red border
                // manually instead, same as the Dropdown fields elsewhere in
                // this form already do.
                style={{
                  borderColor: touched.appointmentDate && errors.appointmentDate ? '#dc3545' : undefined,
                }}
              />
              <span
                className="position-absolute end-0 me-2"
                style={{ top: '20px', transform: 'translateY(-50%)' }}
              >
                <FaCalendarAlt
                  className="text-muted"
                  onClick={() => !isEditMode && !isViewMode && setCalendarPickerOpen(!calendarPickerOpen)}
                />
              </span>
              {calendarPickerOpen && (
                <div style={{ position: 'absolute', top: '45px', left: 0, zIndex: 9999 }}>
                  <DatePicker
                    selected={
                      values.appointmentDate
                        ? (() => {
                          const [year, month, day] = values.appointmentDate.split('-');
                          return new Date(year, month - 1, day); // Safe local date
                        })()
                        : null
                    }
                    onChange={(date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, '0');
                      const day = String(date.getDate()).padStart(2, '0');
                      const formattedDate = `${year}-${month}-${day}`; // Local-safe formatting

                      setFieldValue('appointmentDate', formattedDate);
                      setSelectedDate(formattedDate);
                      setCalendarPickerOpen(false);
                    }}
                    excludeDates={holidayDates?.map((dateStr) => {
                      const [year, month, day] = dateStr.split("-");
                      return new Date(year, month - 1, day);
                    }) || []}
                    filterDate={(date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, "0");
                      const day = String(date.getDate()).padStart(2, "0");
                      const dateString = `${year}-${month}-${day}`;
                      return !holidayDates?.includes(dateString);
                    }}
                    dayClassName={(date) => {
                      const year = date.getFullYear();
                      const month = String(date.getMonth() + 1).padStart(2, "0");
                      const day = String(date.getDate()).padStart(2, "0");
                      const dateString = `${year}-${month}-${day}`;
                      return holidayDates?.includes(dateString) ? "disabled-day" : null;
                    }}
                    minDate={new Date()}
                    inline
                  />
                </div>
              )}
              {touched.appointmentDate && errors.appointmentDate && (
                <div className="invalid-feedback d-block">
                  {errors.appointmentDate}
                </div>
              )}
            </div>
            <div className="position-relative flex-grow-1" ref={timeSlotRef}>
              <Form.Control
                type="text"
                name="appointmentTime"
                value={
                  values.selectedTimeSlots?.length > 0
                    ? values.selectedTimeSlots[0]
                    : values.appointmentTime
                }
                readOnly
                disabled={isViewMode}
                className={isEditMode ? 'bg-white' : 'label-bgcolor'}
                onClick={() => !isViewMode && setShowTimeDropdown(!showTimeDropdown)}
                style={{
                  borderColor: touched.appointmentTime && errors.appointmentTime ? '#dc3545' : undefined,
                }}
              />
              <span
                onClick={() => !isViewMode && setShowTimeDropdown(!showTimeDropdown)}
                className="position-absolute end-0 me-2"
                style={{ cursor: isViewMode ? 'not-allowed' : 'pointer', top: '20px', transform: 'translateY(-50%)' }}
              >
                <FiClock className="text-muted" />
              </span>
              {touched.appointmentTime && errors.appointmentTime && (
                <div className="invalid-feedback d-block">
                  {errors.appointmentTime}
                </div>
              )}

              {showTimeDropdown && (
                <div style={{ position: 'relative' }}>
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    zIndex: 1000,
                    padding: '8px',
                    marginTop: '4px',
                    border: '1px solid #E3EBF8',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                    gap: '8px',
                  }}>
                    {availableTimeSlots.length === 0 ? (
                      <div style={{
                        gridColumn: '1 / -1',
                        textAlign: 'center',
                        padding: '12px',
                        color: '#6c757d',
                        fontSize: '13px',
                      }}>
                        {(!values.doctors || values.doctors.length === 0)
                          ? "Please select a Doctor to view available time slots."
                          : "No time slots available for the selected date."}
                      </div>
                    ) : (
                    availableTimeSlots.map((slot, index) => {
                      const startTime = slot.split(" - ")[0].trim();
                      const isSelected = values.selectedTimeSlots.includes(startTime);
                      return (
                        <button
                          key={index}
                          type="button"
                          onClick={() => handleTimeSlotClick(slot)}
                          style={{
                            backgroundColor: isSelected ? '#E3F2FF' : '#F0F7FF',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            fontSize: '13px',
                            cursor: 'pointer',
                            textAlign: 'center',
                            border: isSelected ? '1px solid #0D6EFD' : '1px solid #E3EBF8',
                            color: isSelected ? '#0D6EFD' : '#212529',
                            transition: 'all 0.2s ease',
                            width: '100%',
                            '&:hover': {
                              backgroundColor: '#E3F2FF',
                              borderColor: '#0D6EFD'
                            }
                          }}
                        >
                          {startTime}
                        </button>
                      );
                    })
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Optional examination room - renders nothing when the clinic has none set up */}
        {showResourceField && (
          <div className="mb-3">
            <Row>
              <ResourceField
                resources={activeResources}
                value={resourceIds}
                onChange={setResourceIds}
                label={isClinicService ? "Examination Room" : "Resource"}
                colMd={12}
                date={values.appointmentDate}
                time={(
                  convertTo24HourFormat([values.selectedTimeSlots?.[0] || values.appointmentTime])?.[0] ||
                  values.selectedTimeSlots?.[0] ||
                  values.appointmentTime ||
                  ""
                ).slice(0, 5)}
                offeringIds={selectedOfferings}
                crewCount={1}
                excludeGroupId={group_id}
                currentLabel={resourceCurrentName}
                disabled={isViewMode || !editable}
              />
            </Row>
          </div>
        )}
        <div className="mb-3">

                                          <Form.Label>Status <FieldHelpTooltip {...HELP_CONTENT.newAppointment.status} /></Form.Label>
                                          <Dropdown
                                            name="status"
                                            value={values.status}
                                            options={bookingStatus?.map((s) => ({
                                              label: s.name,
                                              value: s.id,
                                            }))}
                                          
                                            placeholder="Select Status"
                                            onChange={(e) =>
                                              setFieldValue("status", e.value)
                                            }
                                            onBlur={handleBlur}
                                            className={`w-100 ${
                                              touched.status && errors.status
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            style={{
                                              height: "40px",
                                              backgroundColor: "white",
                                              border:
                                                touched.status && errors.status
                                                  ? "1px solid #dc3545"
                                                  : "1px solid #E9ECEF",
                                            }}
                                          />
                                          {touched.status && errors.status && (
                                            <div className="invalid-feedback d-block">
                                              {errors.status}
                                            </div>
                                          )}
                                        
</div>      
                                      {/* Payment */}
<div className="mb-3">

                                          <Form.Label>Payment
                                             <FieldHelpTooltip
                                              {...providerHelp.payment}
                                             />
                                             </Form.Label>
                                          <Dropdown
                                            name="payment"
                                            value={values.payment}
                                            options={paymentStatus?.map((p) => ({
                                              label: p.name,
                                              value: p.id,
                                            }))}
                                            placeholder="Select Payment"
                                            onChange={(e) => {
                                              setFieldValue("payment", e.value);
                                              const selectedPaymentName =
                                                paymentStatus?.find(
                                                  (p) => p.id === e.value
                                                )?.name;
        
                                              const isPaymentDone = isPaidPaymentStatus(selectedPaymentName);
        
                                              const totalObj = priceSection?.find(
                                                (item) => item.name === "Total"
                                              );
        
                                              const totalAmount = Number(
                                                totalObj?.amount || 0
                                              );
        
                                              if (isPaymentDone) {
                                                setPaidAmount(totalAmount);
                                              } else {
                                                setPaidAmount(0);
                                                // setBalanceDue(totalAmount); //  full amount pending
                                              }
                                            }}
                                        
                                            onBlur={handleBlur}
                                            className={`w-100 ${
                                              touched.payment && errors.payment
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            style={{
                                              height: "40px",
                                              backgroundColor: "white",
                                              border:
                                                touched.payment && errors.payment
                                                  ? "1px solid #dc3545"
                                                  : "1px solid #E9ECEF",
                                            }}
                                          />
        
                                          {touched.payment && errors.payment && (
                                            <div className="invalid-feedback d-block">
                                              {errors.payment}
                                            </div>
                                          )}
</div>
     <div className="mb-4">
  <Form.Label>Price Details</Form.Label>

  {priceSection.map((item, idx) => {
    const isEditable =
      item.type === "service" ||
      item.type === "discount" ||
      item.isCustom;

    return (
      <div className="d-flex gap-2 mb-2" key={idx}>
        <Form.Control
          value={item.name}
          readOnly
          style={{ background: "#f8f9fa" }}
        />

        <Form.Control
          type="number"
          value={item.amount || ""}
          readOnly={!isEditable}
          onChange={(e) =>
            priceChange(e.target.value, item)
          }
        />
      </div>
    );
  })}
</div>

        {/* Action Buttons */}
        {isViewMode && (
          <>
            <div className="d-flex gap-2 mt-4">
              <button
                type="button"
                className="btn flex-grow-1"
                style={{
                  backgroundColor: '#fff',
                  color: '#C9194A',
                  borderRadius: '16px',
                  border: '1px solid #DEE2E6'
                }}
                onClick={handleDelete}
              >
                Delete Appointment
              </button>
              <button
                type="button"
                className="btn flex-grow-1"
                style={{
                  color: '#4B52EC',
                  border: 'none',
                  borderRadius: '16px',
                  border: '1px solid #DEE2E6'
                }}
                onClick={() => onClose('edit')}
              >
                Re-Schedule
              </button>
              <button
                type="button"
                className="btn flex-grow-1"
                style={{
                  backgroundColor: noShowDisabled ? '#fff' : '#FFF0F0',
                  color: noShowDisabled ? '#6C757D' : '#C9194A',
                  borderRadius: '16px',
                  border: noShowDisabled ? '1px solid #DEE2E6' : '1px solid #C9194A',
                  cursor: noShowDisabled ? 'not-allowed' : 'pointer',
                  opacity: noShowDisabled ? 0.6 : 1
                }}
                onClick={() => !noShowDisabled && setShowNoShowConfirm(true)}
                disabled={noShowDisabled}
                title={
                  noShowMarked ? "No Show already marked" :
                    currentStatus === 11 ? "No Show not available after check-in" :
                      isFutureAppointment() ? "No Show not available for future appointments" :
                        currentStatus === 15 ? "No Show not available for completed appointments" :
                          isTodayAppointment() && !timeSlotsPassed ? "No Show available after appointment time has passed" :
                            "Mark as No Show"
                }
              >
                No Show
              </button>
            </div>

            <div className="d-flex gap-2 mt-3">
              <button
                type="button"
                className="btn flex-grow-1"
                style={{
                  backgroundColor: canCheckIn ? '#C9194A' : '#6C757D',
                  color: '#fff',
                  borderRadius: '16px',
                  border: 'none',
                  cursor: canCheckIn ? 'pointer' : 'not-allowed'
                }}
                onClick={canCheckIn ? handleCheckIn : null}
                disabled={!canCheckIn}
                title={noShowMarked ? "Check-In disabled after No Show" : ""}
              >
                Complete Check-In
              </button>
              <button
                type="button"
                className="btn flex-grow-1"
                style={{
                  backgroundColor: canCheckOut ? '#C9194A' : '#6C757D',
                  borderRadius: '16px',
                  color: '#fff',
                  border: 'none',
                  cursor: canCheckOut ? 'pointer' : 'not-allowed'
                }}
                onClick={canCheckOut ? handleCheckout : null}
                disabled={!canCheckOut}
                title={noShowMarked ? "Check-Out disabled after No Show" : ""}
              >
                Complete Check-Out
              </button>
            </div>
          </>
        )}

        {(mode === 'new' || isEditMode) && (
          <div className="d-flex gap-2 mt-4">
           <button
  type="submit"
  className="btn btn-danger w-50 rounded-pill"
  disabled={isSubmitting}
>
  {isSubmitting ? (isEditMode ? 'Updating...' : 'Submitting...') : (isEditMode ? 'Update' : 'Checkout')}
</button>
           <button className="btn btn-light w-50 rounded-pill"
              // type="button"
              // className="btn flex-grow-1"
              // style={{
              //   backgroundColor: '#fff',
              //   color: '#6C757D',
              //   border: '1px solid #DEE2E6',
              //   borderRadius: '16px'
              // }}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        )}

        {/* Booking was created cash/pending — give the vendor a way to
            collect payment online now, without leaving edit mode. Hidden
            once the booking already shows a paid status. */}
        {isEditMode && !isPaidPaymentStatus(
          paymentStatus?.find((p) => p.id === values.payment)?.name
        ) && (
          <div className="d-flex gap-2 mt-3">
            <button
              type="button"
              className="btn btn-danger w-100 rounded-pill"
              disabled={payingOnline}
              onClick={handlePayOnline}
            >
              {payingOnline ? "Processing Payment..." : "Pay Online"}
            </button>
          </div>
        )}
      </Form>
       )
      }}
    </Formik>
      </div>
    
  );
};

export default NewAppointment;
 {/* Confirmation Modals */}
      {/* {showDeleteConfirm && (
        <ConfirmationModal
          show={showDeleteConfirm}
          onClose={() => setShowDeleteConfirm(false)}
          icon={DeleteIcon}
          title="Delete Appointment"
          message="Are you sure want to delete this Appointment?"
          primaryText="Delete"
          secondaryText="Cancel"
          onPrimary={() => {
            confirmDelete();
            setShowDeleteConfirm(false);
          }}
        />
      )}

      <AppointmentModal
        holidayDates={holidayDates}
        show={showModal}
        onHide={handleModalClose}
        reqData={values}
        info={initialData?.details}
        timeSlots={timeSlots}
      />

      {showFollowUpConfirm && (
        <FollowUpConfirmModal
          show={showFollowUpConfirm}
          onYes={handleYesClick}
          onNo={() => setFollowUpConfirm(false)}
        />

      )} */}

      {/* {showNoShowConfirm && (
        <ConfirmationModal
          show={showNoShowConfirm}
          onClose={() => setShowNoShowConfirm(false)}
          icon={DeleteIcon}
          title="Patient didn't visit"
          message="Do you want to close the appointment?"
          primaryText="Yes, close"
          secondaryText="Reschedule"
          onPrimary={() => {
            handleNoShow()
          }}
          onSecondary={() => {
            handleReScheduleRedirect()
          }}
        />
      )} */}